import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw, FiArrowLeft } from "react-icons/fi";
import useTrades from "../../hooks/useTrades";

//old commented code
// const TradeDealPage = () => {
//   const navigate = useNavigate();
//   const {
//     profitableTrades,
//     openTrades,
//     livePrices,
//     allClosedTrades,
//     stats,
//     allStats,
//     loading,
//     error,
//     fetchProfitableTrades,
//     fetchAllClosedTrades,
//     fetchOpenTrades,
//     connectLivePrices,
//     fetchLosingTrades,
//     losingTrades,
//     lossStats,
//   } = useTrades();

//   const [sortKey, setSortKey] = useState("pnl_amount");
//   const [sortDir, setSortDir] = useState("desc");
//   const [view, setView] = useState("all");
//   const [activeTab, setActiveTab] = useState("history");

//   const [activeStrategy, setActiveStrategy] = useState("v1");

//   const [typeFilter, setTypeFilter] = useState("all"); // all | MOMENTUM | PHROSTRAT | CROSSOVER

//   const stratProfitable = useMemo(
//     () =>
//       profitableTrades.filter((t) => (t.strategy || "v1") === activeStrategy),
//     [profitableTrades, activeStrategy],
//   );

//   // const getTradeType = (t) => {
//   //   if (t.trade_type === "MOMENTUM") return "MOMENTUM";
//   //   if (t.trade_type === "PHROSTRAT") return "PHROSTRAT";
//   //   if (t.trade_type === "PHROSTRAT+") return "PHROSTRAT+";
//   //   return "CROSSOVER"; // everything else falls back to crossover
//   // };
//   const getTradeType = (t) => {
//     if (t.trade_type === "MOMENTUM") return "MOMENTUM";
//     if (t.trade_type === "PHROMOMENTUM") return "PHROMOMENTUM"; // ← new
//     if (t.trade_type === "REGMOM") return "REGMOM";
//     if (t.trade_type === "PHROSTRAT") return "PHROSTRAT";
//     if (t.trade_type === "MACDXOVER") return "MACDXOVER";
//     if (t.trade_type === "PHROSTRAT+") return "PHROSTRAT+";
//     return "CROSSOVER";
//   };

//   const matchesType = (t) =>
//     typeFilter === "all" || getTradeType(t) === typeFilter;

//   // const stratOpen = useMemo(
//   //   () => openTrades.filter((t) => (t.strategy || "v1") === activeStrategy),
//   //   [openTrades, activeStrategy],
//   // );
//   // const stratOpen = useMemo(
//   //   () => openTrades.filter((t) => (t.strategy || "v1") === activeStrategy),
//   //   [openTrades, activeStrategy,time],
//   // );
//   const stratOpen = useMemo(
//     () =>
//       openTrades
//         .filter((t) => (t.strategy || "v1") === activeStrategy)
//         .filter(matchesType),
//     [openTrades, activeStrategy, typeFilter],
//   );

//   // Load data on mount
//   // useEffect(() => {
//   //   const loadTrades = async () => {
//   //     const [closedTrades, currentOpenTrades] = await Promise.all([
//   //       fetchProfitableTrades(),
//   //       fetchOpenTrades(),
//   //     ]);

//   //     const allSymbols = [
//   //       ...(closedTrades || []).map((trade) => trade.symbol),
//   //       ...(currentOpenTrades || []).map((trade) => trade.symbol),
//   //     ];

//   //     const uniqueSymbols = [...new Set(allSymbols.filter(Boolean))];

//   //     if (uniqueSymbols.length > 0) {
//   //       connectLivePrices(uniqueSymbols);
//   //     }
//   //   };

//   //   loadTrades();
//   // }, []);

//   //previosu useEffect

//   // useEffect(() => {
//   //   let disconnect = null; // store cleanup function

//   //   const loadTrades = async () => {
//   //     const [closedTrades, currentOpenTrades] = await Promise.all([
//   //       fetchProfitableTrades(),
//   //       fetchOpenTrades(),
//   //     ]);

//   //     const allSymbols = [
//   //       ...(closedTrades || []).map((trade) => trade.symbol),
//   //       ...(currentOpenTrades || []).map((trade) => trade.symbol),
//   //     ];

//   //     const uniqueSymbols = [...new Set(allSymbols.filter(Boolean))];

//   //     if (uniqueSymbols.length > 0) {
//   //       // connectLivePrices should return a cleanup/disconnect function
//   //       disconnect = connectLivePrices(uniqueSymbols);
//   //     }
//   //   };

//   //   loadTrades();

//   //   // Cleanup WebSocket on unmount
//   //   return () => {
//   //     if (typeof disconnect === "function") disconnect();
//   //   };
//   // }, []);

//   useEffect(() => {
//     let disconnect = null;

//     const loadTrades = async () => {
//       const [profitable, losing, closedAll, currentOpen] = await Promise.all([
//         fetchProfitableTrades(),
//         fetchAllClosedTrades(),
//         fetchLosingTrades(),
//         fetchOpenTrades(),
//       ]);

//       const allSymbols = [
//         ...(profitable || []).map((t) => t.symbol),
//         ...(closedAll || []).map((t) => t.symbol),
//         ...(losing || []).map((t) => t.symbol),
//         ...(currentOpen || []).map((t) => t.symbol),
//       ];

//       const uniqueSymbols = [...new Set(allSymbols.filter(Boolean))];
//       if (uniqueSymbols.length > 0)
//         disconnect = connectLivePrices(uniqueSymbols);
//     };

//     loadTrades();
//     return () => {
//       if (typeof disconnect === "function") disconnect();
//     };
//   }, []);

//   // Filter by time
//   // const filtered = useMemo(() => {
//   //   if (view === "all") return profitableTrades;

//   //   const now = new Date();
//   //   const istOffsetMs = 5.5 * 60 * 60 * 1000;
//   //   const ist = new Date(now.getTime() + istOffsetMs);

//   //   if (view === "today") {
//   //     const todayStr = ist.toISOString().slice(0, 10);
//   //     return profitableTrades.filter((t) => {
//   //       return (
//   //         new Date(t.entry_time).toLocaleDateString("en-CA", {
//   //           timeZone: "Asia/Kolkata",
//   //         }) === todayStr
//   //       );
//   //     });
//   //   }

//   //   if (view === "week") {
//   //     const weekAgo = new Date(ist);
//   //     weekAgo.setDate(weekAgo.getDate() - 7);
//   //     return profitableTrades.filter((t) => new Date(t.entry_time) >= weekAgo);
//   //   }

//   //   return profitableTrades;
//   // }, [profitableTrades, view]);
//   const filtered = useMemo(() => {
//     let base = profitableTrades.filter(matchesType); // ← add this line

//     if (view === "all") return base;

//     const now = new Date();
//     const istOffsetMs = 5.5 * 60 * 60 * 1000;
//     const ist = new Date(now.getTime() + istOffsetMs);

//     if (view === "today") {
//       const todayStr = ist.toISOString().slice(0, 10);
//       return base.filter(
//         (t) =>
//           new Date(t.entry_time).toLocaleDateString("en-CA", {
//             timeZone: "Asia/Kolkata",
//           }) === todayStr,
//       );
//     }

//     if (view === "week") {
//       const weekAgo = new Date(ist);
//       weekAgo.setDate(weekAgo.getDate() - 7);
//       return base.filter((t) => new Date(t.entry_time) >= weekAgo);
//     }

//     return base;
//   }, [profitableTrades, view, typeFilter]); // ← add typeFilter to deps
//   // Time-filtered set (used by the summary — ignores typeFilter on purpose)
//   const timeFiltered = useMemo(() => {
//     if (view === "all") return profitableTrades;
//     const now = new Date();
//     const ist = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

//     if (view === "today") {
//       const todayStr = ist.toISOString().slice(0, 10);
//       return profitableTrades.filter(
//         (t) =>
//           new Date(t.entry_time).toLocaleDateString("en-CA", {
//             timeZone: "Asia/Kolkata",
//           }) === todayStr,
//       );
//     }
//     if (view === "week") {
//       const weekAgo = new Date(ist);
//       weekAgo.setDate(weekAgo.getDate() - 7);
//       return profitableTrades.filter((t) => new Date(t.entry_time) >= weekAgo);
//     }
//     return profitableTrades;
//   }, [profitableTrades, view]);

//   //new losses
//   // Filter losing trades by type + time
//   const filteredLosses = useMemo(() => {
//     let base = losingTrades.filter(matchesType);
//     if (view === "all") return base;

//     const ist = new Date(Date.now() + 5.5 * 60 * 60 * 1000);

//     if (view === "today") {
//       const todayStr = ist.toISOString().slice(0, 10);
//       return base.filter(
//         (t) =>
//           new Date(t.entry_time).toLocaleDateString("en-CA", {
//             timeZone: "Asia/Kolkata",
//           }) === todayStr,
//       );
//     }
//     if (view === "week") {
//       const weekAgo = new Date(ist);
//       weekAgo.setDate(weekAgo.getDate() - 7);
//       return base.filter((t) => new Date(t.entry_time) >= weekAgo);
//     }
//     return base;
//   }, [losingTrades, view, typeFilter]);

//   const sortedLosses = useMemo(() => {
//     return [...filteredLosses].sort((a, b) => {
//       const aVal = a[sortKey] ?? 0;
//       const bVal = b[sortKey] ?? 0;
//       if (typeof aVal === "string" && aVal.includes("T"))
//         return sortDir === "desc"
//           ? new Date(bVal) - new Date(aVal)
//           : new Date(aVal) - new Date(bVal);
//       if (typeof aVal === "number")
//         return sortDir === "desc" ? bVal - aVal : aVal - bVal;
//       return 0;
//     });
//   }, [filteredLosses, sortKey, sortDir]);

//   const filteredLossStats = useMemo(() => {
//     const total = filteredLosses.reduce(
//       (s, t) => s + Number(t.pnl_amount || 0),
//       0,
//     );
//     const avg = filteredLosses.length ? total / filteredLosses.length : 0;
//     return {
//       count: filteredLosses.length,
//       total: Number(total.toFixed(2)),
//       avg: Number(avg.toFixed(2)),
//     };
//   }, [filteredLosses]);

//   const groupedLossesByDate = useMemo(() => {
//     const groups = {};
//     sortedLosses.forEach((t) => {
//       const date = new Date(t.entry_time).toLocaleDateString("en-IN", {
//         timeZone: "Asia/Kolkata",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//       if (!groups[date]) groups[date] = { trades: [], dayPnl: 0 };
//       groups[date].trades.push(t);
//       groups[date].dayPnl += Number(t.pnl_amount);
//     });
//     return groups;
//   }, [sortedLosses]);
//   const typeSummary = useMemo(() => {
//     const buildRow = (label, trades) => {
//       const wins = trades.filter((t) => Number(t.pnl_amount) > 0);
//       const losses = trades.filter((t) => Number(t.pnl_amount) <= 0);
//       const totalPnl = trades.reduce(
//         (s, t) => s + Number(t.pnl_amount || 0),
//         0,
//       );
//       const totalPts = trades.reduce(
//         (s, t) => s + Number(t.pnl_points || 0),
//         0,
//       );
//       const best = trades.reduce(
//         (b, t) =>
//           Number(t.pnl_amount) > Number(b?.pnl_amount ?? -Infinity) ? t : b,
//         null,
//       );
//       return {
//         label,
//         total: trades.length,
//         wins: wins.length,
//         losses: losses.length,
//         winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
//         totalPnl,
//         avgPnl: trades.length ? totalPnl / trades.length : 0,
//         avgPts: trades.length ? totalPts / trades.length : 0,
//         best,
//       };
//     };

//     const types = [
//       "MOMENTUM",
//       "PHROSTRAT",
//       "PHROSTRAT+",
//       "PHROMOMENTUM",
//       "REGMOM",
//       "CROSSOVER",
//       "MACDXOVER",
//     ];
//     const rows = types
//       .map((type) => ({
//         key: type,
//         ...buildRow(
//           type,
//           timeFiltered.filter((t) => getTradeType(t) === type),
//         ),
//       }))
//       .filter((r) => r.total > 0);

//     const overall = { key: "ALL", ...buildRow("Overall", timeFiltered) };
//     return { rows, overall };
//   }, [timeFiltered]);
//   // Sort
//   const sorted = useMemo(() => {
//     return [...filtered].sort((a, b) => {
//       const aVal = a[sortKey] ?? 0;
//       const bVal = b[sortKey] ?? 0;
//       if (typeof aVal === "string" && aVal.includes("T"))
//         return sortDir === "desc"
//           ? new Date(bVal) - new Date(aVal)
//           : new Date(aVal) - new Date(bVal);
//       if (typeof aVal === "number")
//         return sortDir === "desc" ? bVal - aVal : aVal - bVal;
//       return 0;
//     });
//   }, [filtered, sortKey, sortDir]);

//   // Filtered stats
//   const filteredStats = useMemo(() => {
//     const total = filtered.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
//     const avg = filtered.length ? total / filtered.length : 0;
//     return {
//       count: filtered.length,
//       total: Number(total.toFixed(2)),
//       avg: Number(avg.toFixed(2)),
//     };
//   }, [filtered]);

//   const typeLabel = (t) =>
//     t === "MOMENTUM"
//       ? "⚡ Momentum"
//       : t === "PHROMOMENTUM"
//         ? "🚀 PhroMomentum"
//         : t === "REGMOM"
//           ? "🕯️ RegMom"
//           : t === "PHROSTRAT"
//             ? "🎯 PhroStrat"
//             : t === "PHROSTRAT+"
//               ? "🎯 PhroStrat+"
//               : t === "MACDXOVER"
//                 ? "📈 Crossover+"
//                 : t === "CROSSOVER"
//                   ? "📊 Crossover"
//                   : t;
//   const typeBadgeCls = (t) =>
//     t === "MOMENTUM"
//       ? "target"
//       : t === "PHROMOMENTUM"
//         ? "target"
//         : t === "REGMOM"
//           ? "signal"
//           : t === "PHROSTRAT"
//             ? "buy"
//             : t === "PHROSTRAT+"
//               ? "buy"
//               : t === "MACDXOVER"
//                 ? "target"
//                 : t === "CROSSOVER"
//                   ? "trail"
//                   : "time";

//   // Group by date
//   const groupedByDate = useMemo(() => {
//     const groups = {};
//     sorted.forEach((t) => {
//       const date = new Date(t.entry_time).toLocaleDateString("en-IN", {
//         timeZone: "Asia/Kolkata",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//       if (!groups[date]) groups[date] = { trades: [], dayPnl: 0 };
//       groups[date].trades.push(t);
//       groups[date].dayPnl += Number(t.pnl_amount);
//     });
//     return groups;
//   }, [sorted]);

//   const handleSort = (key) => {
//     if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
//     else {
//       setSortKey(key);
//       setSortDir("desc");
//     }
//   };

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "pt__th-left" : ""}
//     >
//       {label}
//       {sortKey === field && (
//         <span className="pt__sort">{sortDir === "asc" ? " ↑" : " ↓"}</span>
//       )}
//     </th>
//   );

//   const formatTime = (ts) => {
//     if (!ts) return "—";
//     return new Date(ts).toLocaleString("en-IN", {
//       timeZone: "Asia/Kolkata",
//       day: "2-digit",
//       month: "short",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const getDuration = (entry, exit) => {
//     if (!entry || !exit) return "—";
//     const mins = Math.round((new Date(exit) - new Date(entry)) / 60000);
//     if (mins < 60) return `${mins}m`;
//     return `${Math.floor(mins / 60)}h ${mins % 60}m`;
//   };

//   const getRunningDuration = (entry) => {
//     if (!entry) return "—";
//     const mins = Math.round((Date.now() - new Date(entry)) / 60000);
//     if (mins < 60) return `${mins}m`;
//     return `${Math.floor(mins / 60)}h ${mins % 60}m`;
//   };

//   // Exit reason display
//   const getExitBadge = (reason) => {
//     const map = {
//       TARGET_HIT: { icon: "🎯", label: "Target", cls: "target" },
//       TRAIL_STOP: { icon: "🔒", label: "Trail", cls: "trail" },
//       STOP_LOSS: { icon: "⚠️", label: "Stop loss", cls: "stoploss" },
//       MARKET_CLOSE: { icon: "⏰", label: "Market close", cls: "time" },
//       TIME_EXIT: { icon: "⏰", label: "Time", cls: "time" },
//       SIGNALS_BEARISH: { icon: "🔄", label: "Signals", cls: "signal" },
//       KEY_SIGNALS_BEARISH: { icon: "🔄", label: "Signals", cls: "signal" },
//       MANUAL_RESET: { icon: "🔧", label: "Reset", cls: "time" },
//     };
//     const info = map[reason] || { icon: "❓", label: reason, cls: "time" };
//     return (
//       <span className={`pt__badge pt__badge--${info.cls}`}>
//         {info.icon} {info.label}
//       </span>
//     );
//   };

//   // const todayByType = useMemo(() => {
//   //   const now = new Date();
//   //   const ist = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);
//   //   const todayStr = ist.toISOString().slice(0, 10);

//   //   const todayTrades = (allClosedTrades || []).filter(
//   //     (t) =>
//   //       new Date(t.entry_time).toLocaleDateString("en-CA", {
//   //         timeZone: "Asia/Kolkata",
//   //       }) === todayStr,
//   //   );

//   //   const buildRow = (label, trades) => {
//   //     const wins = trades.filter((t) => Number(t.pnl_amount) > 0);
//   //     const losses = trades.filter((t) => Number(t.pnl_amount) <= 0);
//   //     const winPnl = wins.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
//   //     const lossPnl = losses.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
//   //     const net = winPnl + lossPnl;
//   //     return {
//   //       label,
//   //       total: trades.length,
//   //       wins: wins.length,
//   //       losses: losses.length,
//   //       winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
//   //       winPnl,
//   //       lossPnl,
//   //       net,
//   //     };
//   //   };

//   //   const types = ["MOMENTUM", "PHROSTRAT", "PHROSTRAT+", "CROSSOVER"];
//   //   const rows = types
//   //     .map((type) => ({
//   //       key: type,
//   //       ...buildRow(
//   //         type,
//   //         todayTrades.filter((t) => getTradeType(t) === type),
//   //       ),
//   //     }))
//   //     .filter((r) => r.total > 0);

//   //   const overall = { key: "ALL", ...buildRow("Overall", todayTrades) };
//   //   return { rows, overall, hasData: todayTrades.length > 0 };
//   // }, [allClosedTrades]);
//   const todayByType = useMemo(() => {
//     const now = new Date();
//     const ist = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);
//     const todayStr = ist.toISOString().slice(0, 10);

//     const todayTrades = (allClosedTrades || []).filter(
//       (t) =>
//         new Date(t.entry_time).toLocaleDateString("en-CA", {
//           timeZone: "Asia/Kolkata",
//         }) === todayStr,
//     );

//     const buildRow = (label, trades) => {
//       const wins = trades.filter((t) => Number(t.pnl_amount) > 0);
//       const losses = trades.filter((t) => Number(t.pnl_amount) <= 0);
//       const winPnl = wins.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
//       const lossPnl = losses.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
//       const net = winPnl + lossPnl;
//       return {
//         label,
//         total: trades.length,
//         wins: wins.length,
//         losses: losses.length,
//         winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
//         winPnl,
//         lossPnl,
//         net,
//       };
//     };

//     // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//     // CHANGED: added "PHROMOMENTUM" so PhroMomentum trades
//     // get their own row in the Today-by-type table
//     // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//     const types = [
//       "MOMENTUM",
//       "PHROMOMENTUM",
//       "PHROSTRAT",
//       "PHROSTRAT+",
//       "REGMOM",
//       "CROSSOVER",
//       "MACDXOVER",
//     ];
//     // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

//     const rows = types
//       .map((type) => ({
//         key: type,
//         ...buildRow(
//           type,
//           todayTrades.filter((t) => getTradeType(t) === type),
//         ),
//       }))
//       .filter((r) => r.total > 0);

//     const overall = { key: "ALL", ...buildRow("Overall", todayTrades) };
//     return { rows, overall, hasData: todayTrades.length > 0 };
//   }, [allClosedTrades]);
//   return (
//     <div className="pt">
//       {/* Header */}
//       <div className="pt__header">
//         <div className="pt__header-left">
//           <button className="pt__back" onClick={() => navigate(-1)}>
//             <FiArrowLeft size={14} />
//           </button>
//           <div>
//             <h1 className="pt__title">Trade Dashboard</h1>
//             <p className="pt__sub">
//               Live positions and trade history — BUY only strategy
//             </p>
//           </div>
//         </div>
//         <button
//           className="pt__refresh"
//           onClick={() => {
//             navigate("/logs");
//           }}
//         >
//           Logs
//         </button>

//         <button
//           className="pt__refresh"
//           onClick={() => {
//             fetchProfitableTrades();
//             fetchAllClosedTrades();
//             fetchOpenTrades().then((trades) => {
//               if (trades?.length) {
//                 connectLivePrices(trades.map((t) => t.symbol));
//               }
//             });
//           }}
//         >
//           <FiRefreshCw size={14} /> Refresh
//         </button>
//       </div>

//       {error && <div className="pt__error">{error}</div>}

//       {/* ━━━ TABS ━━━ */}
//       {/* <div className="pt__tabs">
//         <button
//           className={`pt__tab ${activeTab === "history" ? "pt__tab--active" : ""}`}
//           onClick={() => setActiveTab("history")}
//         >
//           Trade History
//           {filteredStats.count > 0 && (
//             <span className="pt__tab-badge">{filteredStats.count}</span>
//           )}
//         </button>
//         <button
//           className={`pt__tab ${activeTab === "open" ? "pt__tab--active" : ""}`}
//           onClick={() => setActiveTab("open")}
//         >
//           <span className="pt__live-dot" />
//           Uptrend Stocks
//           {openTrades.length > 0 && (
//             <span className="pt__tab-badge">{openTrades.length}</span>
//           )}
//         </button>
//       </div> */}
//       <div className="pt__tabs">
//         <button
//           className={`pt__tab ${activeTab === "open" ? "pt__tab--active" : ""}`}
//           onClick={() => setActiveTab("open")}
//         >
//           <span className="pt__live-dot" />
//           Open Trades
//           {openTrades.length > 0 && (
//             <span className="pt__tab-badge">{openTrades.length}</span>
//           )}
//         </button>
//         <button
//           className={`pt__tab ${activeTab === "losses" ? "pt__tab--active" : ""}`}
//           onClick={() => setActiveTab("losses")}
//         >
//           Losing Trades
//           {filteredLossStats.count > 0 && (
//             <span className="pt__tab-badge pt__tab-badge--red">
//               {filteredLossStats.count}
//             </span>
//           )}
//         </button>

//         <button
//           className={`pt__tab ${activeTab === "history" ? "pt__tab--active" : ""}`}
//           onClick={() => setActiveTab("history")}
//         >
//           Trade History (Close Trades)
//           {filteredStats.count > 0 && (
//             <span className="pt__tab-badge">{filteredStats.count}</span>
//           )}
//         </button>
//       </div>

//       {/* ━━━ TAB: TRADE HISTORY ━━━ */}
//       {activeTab === "history" && (
//         <>
//           {/* Stats */}
//           {stats && (
//             <>
//               <div className="pt__filters pt__filters--type">
//                 {[
//                   { id: "all", label: "All types" },
//                   { id: "MOMENTUM", label: "⚡ Momentum" },
//                   { id: "PHROSTRAT", label: "🎯 PhroStrat" },
//                   { id: "PHROSTRAT+", label: "🎯 PhroStrat+" },
//                   { id: "PHROMOMENTUM", label: "🚀 PhroMomentum" },
//                   { id: "REGMOM", label: "🕯️ RegMom" },
//                   { id: "MACDXOVER", label: "📈 Crossover+" },
//                   { id: "CROSSOVER", label: "📊 Crossover" },
//                 ].map((f) => (
//                   <button
//                     key={f.id}
//                     className={`pt__filter ${typeFilter === f.id ? "pt__filter--active" : ""}`}
//                     onClick={() => setTypeFilter(f.id)}
//                   >
//                     {f.label}
//                   </button>
//                 ))}
//               </div>
//               {typeSummary.rows.length > 0 && (
//                 <div className="pt__summary-section">
//                   <div className="pt__section-title">
//                     Strategy comparison ({view})
//                   </div>
//                   <div className="pt__table-wrap">
//                     <table className="pt__table">
//                       <thead>
//                         <tr>
//                           <th className="pt__th-left">Type</th>
//                           <th>Trades</th>
//                           <th>Wins</th>
//                           <th>Losses</th>
//                           <th>Win rate</th>
//                           <th>Total P&L</th>
//                           <th>Avg P&L</th>
//                           <th>Avg pts</th>
//                           <th>Best trade</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {typeSummary.rows.map((r) => (
//                           <tr key={r.key}>
//                             <td className="pt__td-name">
//                               <span
//                                 className={`pt__badge pt__badge--${typeBadgeCls(r.key)}`}
//                               >
//                                 {typeLabel(r.key)}
//                               </span>
//                             </td>
//                             <td className="pt__num">{r.total}</td>
//                             <td className="pt__num pt__green">{r.wins}</td>
//                             <td className="pt__num pt__red">{r.losses}</td>
//                             <td className="pt__num">
//                               <b
//                                 className={
//                                   r.winRate >= 50 ? "pt__green" : "pt__red"
//                                 }
//                               >
//                                 {r.winRate.toFixed(1)}%
//                               </b>
//                             </td>
//                             <td
//                               className={`pt__num ${r.totalPnl >= 0 ? "pt__green" : "pt__red"}`}
//                             >
//                               {r.totalPnl >= 0 ? "+" : "-"}₹
//                               {Math.abs(r.totalPnl).toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </td>
//                             <td
//                               className={`pt__num ${r.avgPnl >= 0 ? "pt__green" : "pt__red"}`}
//                             >
//                               {r.avgPnl >= 0 ? "+" : "-"}₹
//                               {Math.abs(r.avgPnl).toFixed(0)}
//                             </td>
//                             <td
//                               className={`pt__num ${r.avgPts >= 0 ? "pt__green" : "pt__red"}`}
//                             >
//                               {r.avgPts >= 0 ? "+" : ""}
//                               {r.avgPts.toFixed(1)}
//                             </td>
//                             <td className="pt__num">
//                               {r.best
//                                 ? `${r.best.symbol} +₹${Number(r.best.pnl_amount).toFixed(0)}`
//                                 : "—"}
//                             </td>
//                           </tr>
//                         ))}

//                         {/* Overall row */}
//                         <tr className="pt__summary-total">
//                           <td className="pt__td-name">
//                             <b>Overall</b>
//                           </td>
//                           <td className="pt__num">
//                             <b>{typeSummary.overall.total}</b>
//                           </td>
//                           <td className="pt__num pt__green">
//                             <b>{typeSummary.overall.wins}</b>
//                           </td>
//                           <td className="pt__num pt__red">
//                             <b>{typeSummary.overall.losses}</b>
//                           </td>
//                           <td className="pt__num">
//                             <b
//                               className={
//                                 typeSummary.overall.winRate >= 50
//                                   ? "pt__green"
//                                   : "pt__red"
//                               }
//                             >
//                               {typeSummary.overall.winRate.toFixed(1)}%
//                             </b>
//                           </td>
//                           <td
//                             className={`pt__num ${typeSummary.overall.totalPnl >= 0 ? "pt__green" : "pt__red"}`}
//                           >
//                             <b>
//                               {typeSummary.overall.totalPnl >= 0 ? "+" : "-"}₹
//                               {Math.abs(
//                                 typeSummary.overall.totalPnl,
//                               ).toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </b>
//                           </td>
//                           <td
//                             className={`pt__num ${typeSummary.overall.avgPnl >= 0 ? "pt__green" : "pt__red"}`}
//                           >
//                             <b>
//                               {typeSummary.overall.avgPnl >= 0 ? "+" : "-"}₹
//                               {Math.abs(typeSummary.overall.avgPnl).toFixed(0)}
//                             </b>
//                           </td>
//                           <td
//                             className={`pt__num ${typeSummary.overall.avgPts >= 0 ? "pt__green" : "pt__red"}`}
//                           >
//                             <b>
//                               {typeSummary.overall.avgPts >= 0 ? "+" : ""}
//                               {typeSummary.overall.avgPts.toFixed(1)}
//                             </b>
//                           </td>
//                           <td className="pt__num">—</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//               <div className="pt__stats">
//                 <div className="pt__stat pt__stat--highlight">
//                   <span>Total profit</span>
//                   <b>+₹{filteredStats.total.toLocaleString("en-IN")}</b>
//                 </div>
//                 <div className="pt__stat">
//                   <span>Winning trades</span>
//                   <b>{filteredStats.count}</b>
//                 </div>
//                 <div className="pt__stat">
//                   <span>Avg profit / trade</span>
//                   <b>+₹{filteredStats.avg.toLocaleString("en-IN")}</b>
//                 </div>
//                 <div className="pt__stat">
//                   <span>Avg points / trade</span>
//                   <b>+{stats.avgPoints} pts</b>
//                 </div>
//                 {stats.bestTrade && (
//                   <div className="pt__stat">
//                     <span>Best trade</span>
//                     <b>
//                       {stats.bestTrade.symbol} +₹
//                       {Number(stats.bestTrade.pnl_amount).toLocaleString(
//                         "en-IN",
//                       )}
//                     </b>
//                   </div>
//                 )}
//               </div>
//               {todayByType.hasData && (
//                 <div className="pt__summary-section">
//                   <div className="pt__section-title">Today by type</div>
//                   <div className="pt__table-wrap">
//                     <table className="pt__table">
//                       <thead>
//                         <tr>
//                           <th className="pt__th-left">Type</th>
//                           <th>Trades</th>
//                           <th>Wins</th>
//                           <th>Losses</th>
//                           <th>Win rate</th>
//                           <th>Gain</th>
//                           <th>Loss</th>
//                           <th>Net P&L</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {todayByType.rows.map((r) => (
//                           <tr key={r.key}>
//                             <td className="pt__td-name">
//                               <span
//                                 className={`pt__badge pt__badge--${typeBadgeCls(r.key)}`}
//                               >
//                                 {typeLabel(r.key)}
//                               </span>
//                             </td>
//                             <td className="pt__num">{r.total}</td>
//                             <td className="pt__num pt__green">{r.wins}</td>
//                             <td className="pt__num pt__red">{r.losses}</td>
//                             <td className="pt__num">
//                               <b
//                                 className={
//                                   r.winRate >= 50 ? "pt__green" : "pt__red"
//                                 }
//                               >
//                                 {r.winRate.toFixed(1)}%
//                               </b>
//                             </td>
//                             <td className="pt__num pt__green">
//                               +₹
//                               {r.winPnl.toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </td>
//                             <td className="pt__num pt__red">
//                               {r.lossPnl < 0 ? "-" : ""}₹
//                               {Math.abs(r.lossPnl).toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </td>
//                             <td
//                               className={`pt__num pt__pnl-highlight ${r.net >= 0 ? "pt__green" : "pt__red"}`}
//                             >
//                               {r.net >= 0 ? "+" : "-"}₹
//                               {Math.abs(r.net).toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </td>
//                           </tr>
//                         ))}

//                         <tr className="pt__summary-total">
//                           <td className="pt__td-name">
//                             <b>Overall (today)</b>
//                           </td>
//                           <td className="pt__num">
//                             <b>{todayByType.overall.total}</b>
//                           </td>
//                           <td className="pt__num pt__green">
//                             <b>{todayByType.overall.wins}</b>
//                           </td>
//                           <td className="pt__num pt__red">
//                             <b>{todayByType.overall.losses}</b>
//                           </td>
//                           <td className="pt__num">
//                             <b
//                               className={
//                                 todayByType.overall.winRate >= 50
//                                   ? "pt__green"
//                                   : "pt__red"
//                               }
//                             >
//                               {todayByType.overall.winRate.toFixed(1)}%
//                             </b>
//                           </td>
//                           <td className="pt__num pt__green">
//                             <b>
//                               +₹
//                               {todayByType.overall.winPnl.toLocaleString(
//                                 "en-IN",
//                                 { maximumFractionDigits: 0 },
//                               )}
//                             </b>
//                           </td>
//                           <td className="pt__num pt__red">
//                             <b>
//                               {todayByType.overall.lossPnl < 0 ? "-" : ""}₹
//                               {Math.abs(
//                                 todayByType.overall.lossPnl,
//                               ).toLocaleString("en-IN", {
//                                 maximumFractionDigits: 0,
//                               })}
//                             </b>
//                           </td>
//                           <td
//                             className={`pt__num pt__pnl-highlight ${todayByType.overall.net >= 0 ? "pt__green" : "pt__red"}`}
//                           >
//                             <b>
//                               {todayByType.overall.net >= 0 ? "+" : "-"}₹
//                               {Math.abs(todayByType.overall.net).toLocaleString(
//                                 "en-IN",
//                                 { maximumFractionDigits: 0 },
//                               )}
//                             </b>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//               {allStats && (
//                 <div className="pt__stat">
//                   <span>Overall win rate</span>
//                   <b>
//                     {allStats.winRate}% ({allStats.winners}W / {allStats.losers}
//                     L)
//                   </b>
//                 </div>
//               )}
//             </>
//           )}

//           {/* How profits were made */}
//           {stats?.byReason && Object.keys(stats.byReason).length > 0 && (
//             <div className="pt__reason-section">
//               <div className="pt__section-title">
//                 How trades generate profit
//               </div>
//               <div className="pt__reason-row">
//                 {Object.entries(stats.byReason).map(([reason, data]) => (
//                   <div key={reason} className="pt__reason-card">
//                     <span
//                       className={`pt__reason-badge pt__reason-badge--${reason.toLowerCase()}`}
//                     >
//                       {reason === "TARGET_HIT"
//                         ? "🎯"
//                         : reason === "TRAIL_STOP"
//                           ? "🔒"
//                           : "⏰"}{" "}
//                       {reason.replace(/_/g, " ")}
//                     </span>
//                     <b>{data.count} trades</b>
//                     <small>+₹{data.total.toFixed(0)}</small>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Top Symbols */}
//           {stats?.topSymbols?.length > 0 && (
//             <div className="pt__top-section">
//               <div className="pt__section-title">Top profitable stocks</div>
//               <div className="pt__symbol-chips">
//                 {stats.topSymbols.map((s) => (
//                   <div
//                     key={s.symbol}
//                     className="pt__symbol-chip"
//                     onClick={() => navigate(`/stockdetail/${s.symbol}`)}
//                   >
//                     <span className="pt__chip-name">{s.symbol}</span>
//                     <span className="pt__chip-pnl">+₹{s.total.toFixed(0)}</span>
//                     <small>{s.count} trades</small>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Time Filter */}
//           <div className="pt__filters">
//             {[
//               { id: "all", label: "All time" },
//               { id: "today", label: "Today" },
//               { id: "week", label: "This week" },
//             ].map((f) => (
//               <button
//                 key={f.id}
//                 className={`pt__filter ${view === f.id ? "pt__filter--active" : ""}`}
//                 onClick={() => setView(f.id)}
//               >
//                 {f.label}
//               </button>
//             ))}
//             <span className="pt__filter-summary">
//               {filteredStats.count} trades · +₹
//               {filteredStats.total.toLocaleString("en-IN")}
//             </span>
//           </div>

//           {/* ━━━ CLOSED TRADES TABLE ━━━ */}
//           {loading ? (
//             <div className="pt__loading">Loading trades...</div>
//           ) : sorted.length === 0 ? (
//             <div className="pt__empty">
//               <div className="pt__empty-icon">📈</div>
//               <div className="pt__empty-title">No profitable trades yet</div>
//               <div className="pt__empty-sub">
//                 Trades appear here when target or trailing stop is hit
//               </div>
//             </div>
//           ) : (
//             <div className="pt__table-wrap">
//               <table className="pt__table stock-table">
//                 <thead>
//                   <tr>
//                     <SortTh label="Symbol" field="symbol" align="left" />
//                     <SortTh label="Entry" field="entry_price" />
//                     <SortTh label="Exit" field="exit_price" />
//                     <th>LTP</th>
//                     <th>Stop loss</th>
//                     <th>Target</th>
//                     <SortTh label="Qty" field="quantity" />
//                     <SortTh label="P&L pts" field="pnl_points" />
//                     <SortTh label="P&L amount" field="pnl_amount" />
//                     <SortTh label="Exit reason" field="exit_reason" />
//                     <SortTh label="Score" field="confluence_score" />
//                     <th>Type</th>
//                     <SortTh label="Entry time" field="entry_time" />
//                     <SortTh label="Exit time" field="exit_time" />
//                     <th>Duration</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {sorted.map((t) => {
//                     const entryPrice = Number(t.entry_price);
//                     const exitPrice = Number(t.exit_price);
//                     const quantity = Number(t.quantity);

//                     // This page uses a BUY-only strategy
//                     const calculatedPnlPoints = exitPrice - entryPrice;
//                     const calculatedPnlAmount = calculatedPnlPoints * quantity;

//                     const pnlPositive = calculatedPnlAmount >= 0;

//                     const rawLtp =
//                       livePrices[t.symbol]?.ltp ?? t.snapshot_ltp ?? null;

//                     const ltp = rawLtp !== null ? Number(rawLtp) : null;
//                     const hasLtp = Number.isFinite(ltp);
//                     // const pnlPositive = Number(t.pnl_amount) >= 0;
//                     // const ltp = Number(livePrices[t.symbol]?.ltp);
//                     // const ltp =
//                     //   livePrices[t.symbol]?.ltp || t.snapshot_ltp || null;
//                     // const hasLtp = Number.isFinite(ltp);
//                     return (
//                       <tr
//                         key={t.id}
//                         className="pt__row"
//                         onClick={() =>
//                           navigate(
//                             `/signals/${t.symbol}/${t.security_id || ""}`,
//                           )
//                         }
//                       >
//                         <td className="pt__td-name">
//                           <span className="pt__symbol-name">{t.symbol}</span>
//                         </td>
//                         <td className="pt__num">
//                           ₹
//                           {Number(t.entry_price).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">
//                           ₹
//                           {Number(t.exit_price).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">
//                           {hasLtp ? (
//                             <span>
//                               ₹
//                               {ltp.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 1,
//                                 maximumFractionDigits: 2,
//                               })}
//                             </span>
//                           ) : (
//                             <span className="pt__muted">—</span>
//                           )}
//                         </td>
//                         <td className="pt__num pt__red">
//                           ₹
//                           {Number(t.stop_loss).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num pt__green">
//                           ₹
//                           {Number(t.target).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">{t.quantity}</td>
//                         {/* <td
//                           className={`pt__num ${pnlPositive ? "pt__green" : "pt__red"}`}
//                         >
//                           {pnlPositive ? "+" : ""}
//                           {Number(t.pnl_points).toFixed(1)} pts
//                         </td> */}
//                         <td
//                           className={`pt__num ${
//                             pnlPositive ? "pt__green" : "pt__red"
//                           }`}
//                         >
//                           {calculatedPnlPoints >= 0 ? "+" : ""}
//                           {calculatedPnlPoints.toFixed(1)} pts
//                         </td>
//                         <td
//                           className={`pt__num pt__pnl-highlight ${pnlPositive ? "pt__green" : "pt__red"}`}
//                         >
//                           {pnlPositive ? "+" : ""}₹
//                           {Math.abs(Number(t.pnl_amount)).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         <td>{getExitBadge(t.exit_reason)}</td>
//                         <td className="pt__num">
//                           {t.confluence_score || "—"}/5
//                         </td>
//                         {/* <td>
//                           <span
//                             className={`pt__badge pt__badge--${
//                               t.trade_type === "MOMENTUM"
//                                 ? "target"
//                                 : t.trade_type === "PHROSTRAT"
//                                   ? "buy"
//                                   : "trail"
//                             }`}
//                           >
//                             {t.trade_type === "MOMENTUM"
//                               ? "⚡ Momentum"
//                               : t.trade_type === "PHROSTRAT"
//                                 ? "🎯 PhroStrat"
//                                 : "📊 Crossover"}
//                           </span>
//                         </td> */}
//                         {/* <td>
//                           <span
//                             className={`pt__badge pt__badge--${
//                               t.trade_type === "MOMENTUM"
//                                 ? "target"
//                                 : t.trade_type === "PHROSTRAT+"
//                                   ? "buy"
//                                   : t.trade_type === "PHROSTRAT"
//                                     ? "buy"
//                                     : "trail"
//                             }`}
//                           >
//                             {t.trade_type === "MOMENTUM"
//                               ? "⚡ Momentum"
//                               : t.trade_type === "PHROSTRAT+"
//                                 ? "🎯 PhroStrat+"
//                                 : t.trade_type === "PHROSTRAT"
//                                   ? "🎯 PhroStrat"
//                                   : "📊 Crossover"}
//                           </span>
//                         </td> */}
//                         <td>
//                           <span
//                             className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
//                           >
//                             {typeLabel(getTradeType(t))}
//                           </span>
//                         </td>
//                         <td className="pt__num">{formatTime(t.entry_time)}</td>
//                         <td className="pt__num">{formatTime(t.exit_time)}</td>
//                         <td className="pt__num">
//                           {getDuration(t.entry_time, t.exit_time)}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* Day-wise summary */}
//           {Object.keys(groupedByDate).length > 0 && (
//             <div className="pt__day-section">
//               <div className="pt__section-title">Day-wise profit</div>
//               <div className="pt__day-grid">
//                 {Object.entries(groupedByDate).map(([date, data]) => (
//                   <div key={date} className="pt__day-card">
//                     <span className="pt__day-date">{date}</span>
//                     <b className="pt__green">+₹{data.dayPnl.toFixed(0)}</b>
//                     <small>{data.trades.length} winning trades</small>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Explainer */}
//           <div className="pt__explainer">
//             <div className="pt__section-title">How trades generate profit</div>
//             <div className="pt__explain-grid">
//               <div className="pt__explain-card">
//                 <h5>🎯 Target hit</h5>
//                 <p>
//                   Price moved up and reached the target price (entry + 50 pts).
//                   Full planned profit captured.
//                 </p>
//               </div>
//               <div className="pt__explain-card">
//                 <h5>🔒 Trailing stop</h5>
//                 <p>
//                   Price moved past the target. Trailing stop locked profits by
//                   following the price 15 pts behind. Captured more than the
//                   planned target.
//                 </p>
//               </div>
//               <div className="pt__explain-card">
//                 <h5>⏰ Market close</h5>
//                 <p>
//                   Trade was still profitable at 3:15 PM. Auto-sold before market
//                   close to avoid overnight risk.
//                 </p>
//               </div>
//               <div className="pt__explain-card">
//                 <h5>⚠️ Stop loss</h5>
//                 <p>
//                   Price dropped below the stop loss (entry - 25 pts). Auto-sold
//                   to limit the damage. Max loss is always capped.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {/* ━━━ TAB: LOSING TRADES ━━━ */}
//       {activeTab === "losses" && (
//         <>
//           {/* Type filter (reuse existing typeFilter state) */}
//           <div className="pt__filters pt__filters--type">
//             {[
//               { id: "all", label: "All types" },
//               { id: "MOMENTUM", label: "⚡ Momentum" },
//               { id: "PHROSTRAT", label: "🎯 PhroStrat" },
//               { id: "PHROSTRAT+", label: "🎯 PhroStrat+" },
//               { id: "PHROMOMENTUM", label: "🚀 PhroMomentum" },
//               { id: "REGMOM", label: "🕯️ RegMom" },
//               { id: "MACDXOVER", label: "📈 Crossover+" },
//               { id: "CROSSOVER", label: "📊 Crossover" },
//             ].map((f) => (
//               <button
//                 key={f.id}
//                 className={`pt__filter ${typeFilter === f.id ? "pt__filter--active" : ""}`}
//                 onClick={() => setTypeFilter(f.id)}
//               >
//                 {f.label}
//               </button>
//             ))}
//           </div>

//           {/* Loss stats */}
//           {lossStats && (
//             <div className="pt__stats">
//               <div
//                 className="pt__stat pt__stat--highlight"
//                 style={{ borderColor: "#ef4444" }}
//               >
//                 <span>Total loss</span>
//                 <b className="pt__red">
//                   -₹{Math.abs(filteredLossStats.total).toLocaleString("en-IN")}
//                 </b>
//               </div>
//               <div className="pt__stat">
//                 <span>Losing trades</span>
//                 <b>{filteredLossStats.count}</b>
//               </div>
//               <div className="pt__stat">
//                 <span>Avg loss / trade</span>
//                 <b className="pt__red">
//                   -₹{Math.abs(filteredLossStats.avg).toLocaleString("en-IN")}
//                 </b>
//               </div>
//               <div className="pt__stat">
//                 <span>Avg points / trade</span>
//                 <b className="pt__red">{lossStats.avgPoints} pts</b>
//               </div>
//               {lossStats.worstTrade && (
//                 <div className="pt__stat">
//                   <span>Worst trade</span>
//                   <b className="pt__red">
//                     {lossStats.worstTrade.symbol} -₹
//                     {Math.abs(
//                       Number(lossStats.worstTrade.pnl_amount),
//                     ).toLocaleString("en-IN")}
//                   </b>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* WHY trades failed */}
//           {lossStats?.byReason &&
//             Object.keys(lossStats.byReason).length > 0 && (
//               <div className="pt__reason-section">
//                 <div className="pt__section-title">Why trades failed</div>
//                 <div className="pt__reason-row">
//                   {Object.entries(lossStats.byReason)
//                     .sort((a, b) => a[1].total - b[1].total)
//                     .map(([reason, data]) => (
//                       <div key={reason} className="pt__reason-card">
//                         <span
//                           className={`pt__reason-badge pt__reason-badge--${reason.toLowerCase()}`}
//                         >
//                           {reason === "STOP_LOSS"
//                             ? "⚠️"
//                             : reason === "MARKET_CLOSE"
//                               ? "⏰"
//                               : reason === "SIGNALS_BEARISH" ||
//                                   reason === "KEY_SIGNALS_BEARISH"
//                                 ? "🔄"
//                                 : reason === "TIME_EXIT"
//                                   ? "⏰"
//                                   : "❓"}{" "}
//                           {reason.replace(/_/g, " ")}
//                         </span>
//                         <b>{data.count} trades</b>
//                         <small className="pt__red">
//                           -₹{Math.abs(data.total).toFixed(0)}
//                         </small>
//                       </div>
//                     ))}
//                 </div>
//               </div>
//             )}

//           {/* Which strategies lose most */}
//           {lossStats?.byType && Object.keys(lossStats.byType).length > 0 && (
//             <div className="pt__reason-section">
//               <div className="pt__section-title">Losses by strategy</div>
//               <div className="pt__reason-row">
//                 {Object.entries(lossStats.byType)
//                   .sort((a, b) => a[1].total - b[1].total)
//                   .map(([type, data]) => (
//                     <div key={type} className="pt__reason-card">
//                       <span
//                         className={`pt__badge pt__badge--${typeBadgeCls(type)}`}
//                       >
//                         {typeLabel(type)}
//                       </span>
//                       <b>{data.count} trades</b>
//                       <small className="pt__red">
//                         -₹{Math.abs(data.total).toFixed(0)}
//                       </small>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}

//           {/* Worst stocks */}
//           {lossStats?.worstSymbols?.length > 0 && (
//             <div className="pt__top-section">
//               <div className="pt__section-title">Worst performing stocks</div>
//               <div className="pt__symbol-chips">
//                 {lossStats.worstSymbols.map((s) => (
//                   <div
//                     key={s.symbol}
//                     className="pt__symbol-chip"
//                     onClick={() => navigate(`/stockdetail/${s.symbol}`)}
//                   >
//                     <span className="pt__chip-name">{s.symbol}</span>
//                     <span className="pt__chip-pnl pt__red">
//                       -₹{Math.abs(s.total).toFixed(0)}
//                     </span>
//                     <small>{s.count} trades</small>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Time filter */}
//           <div className="pt__filters">
//             {[
//               { id: "all", label: "All time" },
//               { id: "today", label: "Today" },
//               { id: "week", label: "This week" },
//             ].map((f) => (
//               <button
//                 key={f.id}
//                 className={`pt__filter ${view === f.id ? "pt__filter--active" : ""}`}
//                 onClick={() => setView(f.id)}
//               >
//                 {f.label}
//               </button>
//             ))}
//             <span className="pt__filter-summary">
//               {filteredLossStats.count} trades · -₹
//               {Math.abs(filteredLossStats.total).toLocaleString("en-IN")}
//             </span>
//           </div>

//           {/* Losses table */}
//           {loading ? (
//             <div className="pt__loading">Loading losing trades...</div>
//           ) : sortedLosses.length === 0 ? (
//             <div className="pt__empty">
//               <div className="pt__empty-icon">🎉</div>
//               <div className="pt__empty-title">No losing trades</div>
//               <div className="pt__empty-sub">
//                 All trades in this window were profitable
//               </div>
//             </div>
//           ) : (
//             <div className="pt__table-wrap">
//               <table className="pt__table stock-table">
//                 <thead>
//                   <tr>
//                     <SortTh label="Symbol" field="symbol" align="left" />
//                     <SortTh label="Entry" field="entry_price" />
//                     <SortTh label="Exit" field="exit_price" />
//                     <th>LTP</th>
//                     <th>Stop loss</th>
//                     <th>Target</th>
//                     <SortTh label="Qty" field="quantity" />
//                     <SortTh label="P&L pts" field="pnl_points" />
//                     <SortTh label="P&L amount" field="pnl_amount" />
//                     <SortTh label="Exit reason" field="exit_reason" />
//                     <SortTh label="Score" field="confluence_score" />
//                     <th>Type</th>
//                     <SortTh label="Entry time" field="entry_time" />
//                     <SortTh label="Exit time" field="exit_time" />
//                     <th>Duration</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {sortedLosses.map((t) => {
//                     const entryPrice = Number(t.entry_price);
//                     const exitPrice = Number(t.exit_price);
//                     const calculatedPnlPoints = exitPrice - entryPrice;
//                     const rawLtp =
//                       livePrices[t.symbol]?.ltp ?? t.snapshot_ltp ?? null;
//                     const ltp = rawLtp !== null ? Number(rawLtp) : null;
//                     const hasLtp = Number.isFinite(ltp);

//                     return (
//                       <tr
//                         key={t.id}
//                         className="pt__row"
//                         onClick={() =>
//                           navigate(
//                             `/signals/${t.symbol}/${t.security_id || ""}`,
//                           )
//                         }
//                       >
//                         <td className="pt__td-name">
//                           <span className="pt__symbol-name">{t.symbol}</span>
//                         </td>
//                         <td className="pt__num">
//                           ₹
//                           {Number(t.entry_price).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">
//                           ₹
//                           {Number(t.exit_price).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">
//                           {hasLtp ? (
//                             <span>
//                               ₹
//                               {ltp.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 1,
//                                 maximumFractionDigits: 2,
//                               })}
//                             </span>
//                           ) : (
//                             <span className="pt__muted">—</span>
//                           )}
//                         </td>
//                         <td className="pt__num pt__red">
//                           ₹
//                           {Number(t.stop_loss).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num pt__green">
//                           ₹
//                           {Number(t.target).toLocaleString("en-IN", {
//                             minimumFractionDigits: 1,
//                           })}
//                         </td>
//                         <td className="pt__num">{t.quantity}</td>
//                         <td className="pt__num pt__red">
//                           {calculatedPnlPoints.toFixed(1)} pts
//                         </td>
//                         <td className="pt__num pt__pnl-highlight pt__red">
//                           -₹
//                           {Math.abs(Number(t.pnl_amount)).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         <td>{getExitBadge(t.exit_reason)}</td>
//                         <td className="pt__num">
//                           {t.confluence_score || "—"}/5
//                         </td>
//                         <td>
//                           <span
//                             className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
//                           >
//                             {typeLabel(getTradeType(t))}
//                           </span>
//                         </td>
//                         <td className="pt__num">{formatTime(t.entry_time)}</td>
//                         <td className="pt__num">{formatTime(t.exit_time)}</td>
//                         <td className="pt__num">
//                           {getDuration(t.entry_time, t.exit_time)}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* Day-wise loss summary */}
//           {Object.keys(groupedLossesByDate).length > 0 && (
//             <div className="pt__day-section">
//               <div className="pt__section-title">Day-wise losses</div>
//               <div className="pt__day-grid">
//                 {Object.entries(groupedLossesByDate).map(([date, data]) => (
//                   <div key={date} className="pt__day-card">
//                     <span className="pt__day-date">{date}</span>
//                     <b className="pt__red">
//                       -₹{Math.abs(data.dayPnl).toFixed(0)}
//                     </b>
//                     <small>{data.trades.length} losing trades</small>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </>
//       )}
//       {/*
//       <div className="pt__tabs pt__tabs--strategy">
//         {["v1", "v2"].map((v) => (
//           <button
//             key={v}
//             className={`pt__tab ${activeStrategy === v ? "pt__tab--active" : ""}`}
//             onClick={() => setActiveStrategy(v)}
//           >
//             {v === "v1" ? "Strategy 1" : "Strategy 2"}
//             <span className="pt__tab-badge">
//               {openTrades.filter((t) => (t.strategy || "v1") === v).length}
//             </span>
//           </button>
//         ))}
//       </div> */}
//       <div className="pt__tabs pt__tabs--strategy">
//         {/* {["v1", "v2", "v2plus"].map((v) => {
//           const labels = {
//             v1: "Strategy 1",
//             v2: "Strategy 2",
//             v2plus: "Strategy 3",
//           };
//           return (
//             <button
//               key={v}
//               className={`pt__tab ${activeStrategy === v ? "pt__tab--active" : ""}`}
//               onClick={() => setActiveStrategy(v)}
//             >
//               {labels[v]}
//               <span className="pt__tab-badge">
//                 {openTrades.filter((t) => (t.strategy || "v1") === v).length}
//               </span>
//             </button>
//           );
//         })} */}
//         {["v1", "v2", "v2plus", "momentum", "macdxover", "regmom"].map((v) => {
//           const labels = {
//             v1: "Strategy 1",
//             v2: "Strategy 2 (PhroStrat)",
//             v2plus: "Strategy 3 (PhroStrat+)",
//             momentum: "Strategy 4 (Momentum)",
//             macdxover: "Strategy 5 (Crossover+)",
//             regmom: "Strategy 6 (RegMom)",
//           };
//           return (
//             <button
//               key={v}
//               className={`pt__tab ${activeStrategy === v ? "pt__tab--active" : ""}`}
//               onClick={() => setActiveStrategy(v)}
//             >
//               {labels[v]}
//               <span className="pt__tab-badge">
//                 {openTrades.filter((t) => (t.strategy || "v1") === v).length}
//               </span>
//             </button>
//           );
//         })}
//       </div>

//       {/* ━━━ TAB: OPEN POSITIONS ━━━ */}
//       {activeTab === "open" && (
//         <>
//           {openTrades.length > 0 ? (
//             <div className="pt__open-section">
//               <div className="pt__section-title">
//                 <span className="pt__live-dot" />
//                 Open positions ({openTrades.length})
//               </div>
//               <div className="pt__table-wrap">
//                 <table className="pt__table ">
//                   <thead>
//                     <tr>
//                       <th className="pt__th-left">Symbol</th>
//                       <th>Entry</th>
//                       <th>LTP</th>
//                       <th>Stop loss</th>
//                       <th>Target</th>
//                       <th>Qty</th>
//                       <th>Live P&L</th>
//                       <th>Score</th>
//                       <th>Type</th>
//                       <th>Progress</th>
//                       <th>Running</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {stratOpen?.map((t) => {
//                       // const ltp = livePrices[t.symbol]?.ltp || null;
//                       const ltp =
//                         livePrices[t.symbol]?.ltp || t.snapshot_ltp || null;
//                       // const isBuy = t.direction === "BUY";
//                       const pnl = ltp
//                         ? (ltp - t.entry_price) * t.quantity
//                         : null;
//                       const pnlPts = ltp ? ltp - t.entry_price : null;
//                       const isProfit = pnl !== null && pnl >= 0;
//                       // const pnl = ltp
//                       //   ? (isBuy ? ltp - t.entry_price : t.entry_price - ltp) *
//                       //     t.quantity
//                       //   : null;
//                       // const pnlPts = ltp
//                       //   ? isBuy
//                       //     ? ltp - t.entry_price
//                       //     : t.entry_price - ltp
//                       //   : null;
//                       // const isProfit = pnl !== null && pnl >= 0;
//                       // Progress: how far between SL and Target
//                       const totalRange = t.target - t.stop_loss;
//                       const currentPos = ltp
//                         ? ((ltp - t.stop_loss) / totalRange) * 100
//                         : 50;
//                       const clampedProgress = Math.max(
//                         0,
//                         Math.min(100, currentPos),
//                       );

//                       return (
//                         <tr
//                           key={t.id}
//                           className="pt__row pt__row--open"
//                           onClick={() =>
//                             navigate(
//                               `/signals/${t.symbol}/${t.security_id || ""}`,
//                             )
//                           }
//                         >
//                           <td className="pt__td-name">
//                             <span className="pt__symbol-name">{t.symbol}</span>
//                             <span className="pt__badge pt__badge--buy">
//                               BUY
//                             </span>
//                           </td>
//                           <td className="pt__num">
//                             ₹
//                             {Number(t.entry_price).toLocaleString("en-IN", {
//                               minimumFractionDigits: 1,
//                             })}
//                           </td>
//                           <td className="pt__num">
//                             {ltp ? (
//                               <span
//                                 className={isProfit ? "pt__green" : "pt__red"}
//                               >
//                                 ₹
//                                 {ltp.toLocaleString("en-IN", {
//                                   minimumFractionDigits: 1,
//                                 })}
//                                 <small className="pt__ltp-diff">
//                                   {" "}
//                                   ({pnlPts >= 0 ? "+" : ""}
//                                   {pnlPts?.toFixed(1)})
//                                 </small>
//                               </span>
//                             ) : (
//                               <span className="pt__muted">—</span>
//                             )}
//                           </td>
//                           <td className="pt__num pt__red">
//                             ₹
//                             {Number(t.stop_loss).toLocaleString("en-IN", {
//                               minimumFractionDigits: 1,
//                             })}
//                           </td>
//                           <td className="pt__num pt__green">
//                             ₹
//                             {Number(t.target).toLocaleString("en-IN", {
//                               minimumFractionDigits: 1,
//                             })}
//                           </td>
//                           <td className="pt__num">{t.quantity}</td>
//                           {/* <td className={`pt__num ${Number(t.pnl_points) >= 0 ? "pt__green" : "pt__red"}`}>
//   {Number(t.pnl_points) >= 0 ? "+" : ""}
//   {Number(t.pnl_points).toFixed(1)} pts
// </td> */}
//                           <td className="pt__num">
//                             {pnl !== null ? (
//                               <span
//                                 className={`pt__pnl-highlight ${isProfit ? "pt__green" : "pt__red"}`}
//                               >
//                                 {isProfit ? "+" : ""}₹{Math.abs(pnl).toFixed(0)}
//                               </span>
//                             ) : (
//                               "—"
//                             )}
//                           </td>
//                           <td className="pt__num">
//                             {t.confluence_score || "—"}/5
//                           </td>
//                           {/* <td>
//                             <span
//                               className={`pt__badge pt__badge--${t.trade_type === "MOMENTUM" ? "target" : "trail"}`}
//                             >
//                               {t.trade_type === "MOMENTUM" ? "⚡" : "📊"}
//                             </span>
//                           </td> */}
//                           <td>
//                             <span
//                               className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
//                             >
//                               {typeLabel(getTradeType(t))}
//                             </span>
//                           </td>
//                           <td className="pt__num" style={{ minWidth: 100 }}>
//                             <div className="pt__progress-bar">
//                               <div
//                                 className={`pt__progress-fill ${isProfit ? "pt__progress-fill--green" : "pt__progress-fill--red"}`}
//                                 style={{ width: `${clampedProgress}%` }}
//                               />
//                               <div
//                                 className="pt__progress-entry"
//                                 style={{
//                                   left: `${((t.entry_price - t.stop_loss) / totalRange) * 100}%`,
//                                 }}
//                               />
//                             </div>
//                             <small className="pt__progress-label">
//                               {ltp && ltp >= t.entry_price
//                                 ? `${Math.round(((ltp - t.entry_price) / (t.target - t.entry_price)) * 100)}% to target`
//                                 : ltp
//                                   ? `${Math.round(((t.entry_price - ltp) / (t.entry_price - t.stop_loss)) * 100)}% to SL`
//                                   : "waiting..."}
//                             </small>
//                           </td>
//                           <td className="pt__num pt__muted">
//                             {getRunningDuration(t.entry_time)}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           ) : (
//             <div className="pt__empty">
//               <div className="pt__empty-icon">📭</div>
//               <div className="pt__empty-title">No open positions</div>
//               <div className="pt__empty-sub">
//                 Active trades will appear here with live P&L tracking
//               </div>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };
// export default TradeDealPage;

//new code

const TradeDealPage1 = () => {
  const navigate = useNavigate();
  const {
    profitableTrades,
    openTrades,
    livePrices,
    allClosedTrades,
    stats,
    allStats,
    loading,
    error,
    fetchProfitableTrades,
    fetchAllClosedTrades,
    fetchOpenTrades,
    connectLivePrices,
    fetchLosingTrades,
    losingTrades,
    lossStats,
  } = useTrades();

  const [sortKey, setSortKey] = useState("pnl_amount");
  const [sortDir, setSortDir] = useState("desc");
  // const [view, setView] = useState("all");
  const [view, setView] = useState("today");
  const [activeTab, setActiveTab] = useState("history");

  const [activeStrategy, setActiveStrategy] = useState("v1");

  const [typeFilter, setTypeFilter] = useState("all"); // all | MOMENTUM | PHROSTRAT | CROSSOVER

  const stratProfitable = useMemo(
    () =>
      profitableTrades.filter((t) => (t.strategy || "v1") === activeStrategy),
    [profitableTrades, activeStrategy],
  );

  const getTradeType = (t) => {
    if (t.trade_type === "MOMENTUM") return "MOMENTUM";
    if (t.trade_type === "PHROMOMENTUM") return "PHROMOMENTUM";
    if (t.trade_type === "PHROMOMENTUM+") return "PHROMOMENTUM+";
    if (t.trade_type === "REGMOM") return "REGMOM";
    if (t.trade_type === "REGMOM_V2") return "REGMOM_V2";
    if (t.trade_type === "PHROSTRAT") return "PHROSTRAT";
    if (t.trade_type === "MACDXOVER") return "MACDXOVER";
    if (t.trade_type === "GANN_SQ9") return "GANN_SQ9"; // ← GANN
    if (t.trade_type === "PHROSTRAT+") return "PHROSTRAT+";
    if (t.trade_type === "EMA_CHANNEL_PULLBACK") return "EMA_CHANNEL_PULLBACK";
    return "CROSSOVER";
  };

  const matchesType = (t) =>
    typeFilter === "all" || getTradeType(t) === typeFilter;

  const stratOpen = useMemo(
    () =>
      openTrades
        .filter((t) => (t.strategy || "v1") === activeStrategy)
        .filter(matchesType),
    [openTrades, activeStrategy, typeFilter],
  );

  useEffect(() => {
    let disconnect = null;

    const loadTrades = async () => {
      const [profitable, losing, closedAll, currentOpen] = await Promise.all([
        fetchProfitableTrades(),
        fetchAllClosedTrades(),
        fetchLosingTrades(),
        fetchOpenTrades(),
      ]);

      const allSymbols = [
        ...(profitable || []).map((t) => t.symbol),
        ...(closedAll || []).map((t) => t.symbol),
        ...(losing || []).map((t) => t.symbol),
        ...(currentOpen || []).map((t) => t.symbol),
      ];

      const uniqueSymbols = [...new Set(allSymbols.filter(Boolean))];
      if (uniqueSymbols.length > 0)
        disconnect = connectLivePrices(uniqueSymbols);
    };

    loadTrades();
    return () => {
      if (typeof disconnect === "function") disconnect();
    };
  }, []);

  //earlier code where we had diff tabs for win and lose
  // const filtered = useMemo(() => {
  //   let base = profitableTrades.filter(matchesType);

  //   if (view === "all") return base;

  //   const now = new Date();
  //   const istOffsetMs = 5.5 * 60 * 60 * 1000;
  //   const ist = new Date(now.getTime() + istOffsetMs);

  //   if (view === "today") {
  //     const todayStr = ist.toISOString().slice(0, 10);
  //     return base.filter(
  //       (t) =>
  //         new Date(t.entry_time).toLocaleDateString("en-CA", {
  //           timeZone: "Asia/Kolkata",
  //         }) === todayStr,
  //     );
  //   }

  //   if (view === "week") {
  //     const weekAgo = new Date(ist);
  //     weekAgo.setDate(weekAgo.getDate() - 7);
  //     return base.filter((t) => new Date(t.entry_time) >= weekAgo);
  //   }

  //   return base;
  // }, [profitableTrades, view, typeFilter]);

  //new with one
  const filtered = useMemo(() => {
    const combined = [...profitableTrades, ...losingTrades];
    let base = combined.filter(matchesType);

    if (view === "all") return base;

    const ist = new Date(Date.now() + 5.5 * 60 * 60 * 1000);

    if (view === "today") {
      const todayStr = ist.toISOString().slice(0, 10);
      return base.filter(
        (t) =>
          new Date(t.entry_time).toLocaleDateString("en-CA", {
            timeZone: "Asia/Kolkata",
          }) === todayStr,
      );
    }

    if (view === "week") {
      const weekAgo = new Date(ist);
      weekAgo.setDate(weekAgo.getDate() - 7);
      return base.filter((t) => new Date(t.entry_time) >= weekAgo);
    }

    return base;
  }, [profitableTrades, losingTrades, view, typeFilter]);

  // Time-filtered set (used by the summary — ignores typeFilter on purpose)
  const timeFiltered = useMemo(() => {
    if (view === "all") return profitableTrades;
    const now = new Date();
    const ist = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

    if (view === "today") {
      const todayStr = ist.toISOString().slice(0, 10);
      return profitableTrades.filter(
        (t) =>
          new Date(t.entry_time).toLocaleDateString("en-CA", {
            timeZone: "Asia/Kolkata",
          }) === todayStr,
      );
    }
    if (view === "week") {
      const weekAgo = new Date(ist);
      weekAgo.setDate(weekAgo.getDate() - 7);
      return profitableTrades.filter((t) => new Date(t.entry_time) >= weekAgo);
    }
    return profitableTrades;
  }, [profitableTrades, view]);

  // Filter losing trades by type + time
  const filteredLosses = useMemo(() => {
    let base = losingTrades.filter(matchesType);
    if (view === "all") return base;

    const ist = new Date(Date.now() + 5.5 * 60 * 60 * 1000);

    if (view === "today") {
      const todayStr = ist.toISOString().slice(0, 10);
      return base.filter(
        (t) =>
          new Date(t.entry_time).toLocaleDateString("en-CA", {
            timeZone: "Asia/Kolkata",
          }) === todayStr,
      );
    }
    if (view === "week") {
      const weekAgo = new Date(ist);
      weekAgo.setDate(weekAgo.getDate() - 7);
      return base.filter((t) => new Date(t.entry_time) >= weekAgo);
    }
    return base;
  }, [losingTrades, view, typeFilter]);

  const sortedLosses = useMemo(() => {
    return [...filteredLosses].sort((a, b) => {
      const aVal = a[sortKey] ?? 0;
      const bVal = b[sortKey] ?? 0;
      if (typeof aVal === "string" && aVal.includes("T"))
        return sortDir === "desc"
          ? new Date(bVal) - new Date(aVal)
          : new Date(aVal) - new Date(bVal);
      if (typeof aVal === "number")
        return sortDir === "desc" ? bVal - aVal : aVal - bVal;
      return 0;
    });
  }, [filteredLosses, sortKey, sortDir]);

  // const filteredLossStats = useMemo(() => {
  //   const total = filteredLosses.reduce(
  //     (s, t) => s + Number(t.pnl_amount || 0),
  //     0,
  //   );
  //   const avg = filteredLosses.length ? total / filteredLosses.length : 0;
  //   return {
  //     count: filteredLosses.length,
  //     total: Number(total.toFixed(2)),
  //     avg: Number(avg.toFixed(2)),
  //   };
  // }, [filteredLosses]);
  const filteredLossStats = useMemo(() => {
    const pnl = (t) =>
      (Number(t.exit_price) - Number(t.entry_price)) * Number(t.quantity);
    const total = filteredLosses.reduce((s, t) => s + pnl(t), 0);
    const avg = filteredLosses.length ? total / filteredLosses.length : 0;
    return {
      count: filteredLosses.length,
      total: Number(total.toFixed(2)),
      avg: Number(avg.toFixed(2)),
    };
  }, [filteredLosses]);

  const groupedLossesByDate = useMemo(() => {
    const groups = {};
    sortedLosses.forEach((t) => {
      const date = new Date(t.entry_time).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      if (!groups[date]) groups[date] = { trades: [], dayPnl: 0 };
      groups[date].trades.push(t);
      groups[date].dayPnl += Number(t.pnl_amount);
    });
    return groups;
  }, [sortedLosses]);

  const typeSummary = useMemo(() => {
    // const buildRow = (label, trades) => {
    //   const wins = trades.filter((t) => Number(t.pnl_amount) > 0);
    //   const losses = trades.filter((t) => Number(t.pnl_amount) <= 0);
    //   const totalPnl = trades.reduce(
    //     (s, t) => s + Number(t.pnl_amount || 0),
    //     0,
    //   );
    //   const totalPts = trades.reduce(
    //     (s, t) => s + Number(t.pnl_points || 0),
    //     0,
    //   );
    //   const best = trades.reduce(
    //     (b, t) =>
    //       Number(t.pnl_amount) > Number(b?.pnl_amount ?? -Infinity) ? t : b,
    //     null,
    //   );
    //   return {
    //     label,
    //     total: trades.length,
    //     wins: wins.length,
    //     losses: losses.length,
    //     winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
    //     totalPnl,
    //     avgPnl: trades.length ? totalPnl / trades.length : 0,
    //     avgPts: trades.length ? totalPts / trades.length : 0,
    //     best,
    //   };
    // };
    const buildRow = (label, trades) => {
      const pnl = (t) =>
        (Number(t.exit_price) - Number(t.entry_price)) * Number(t.quantity);

      const wins = trades.filter((t) => pnl(t) > 0);
      const losses = trades.filter((t) => pnl(t) <= 0);
      const winPnl = wins.reduce((s, t) => s + pnl(t), 0);
      const lossPnl = losses.reduce((s, t) => s + pnl(t), 0);
      const net = winPnl + lossPnl;
      return {
        label,
        total: trades.length,
        wins: wins.length,
        losses: losses.length,
        winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
        winPnl,
        lossPnl,
        net,
      };
    };
    const types = [
      "MOMENTUM",
      "PHROSTRAT",
      "PHROSTRAT+",
      "PHROMOMENTUM",
      "PHROMOMENTUM+",
      "EMA_CHANNEL_PULLBACK",
      "REGMOM",
      "REGMOM_V2",
      "GANN_SQ9",
      "CROSSOVER",
      "MACDXOVER",
    ];
    const rows = types
      .map((type) => ({
        key: type,
        ...buildRow(
          type,
          timeFiltered.filter((t) => getTradeType(t) === type),
        ),
      }))
      .filter((r) => r.total > 0);

    const overall = { key: "ALL", ...buildRow("Overall", timeFiltered) };
    return { rows, overall };
  }, [timeFiltered]);

  // Sort
  const sorted = useMemo(() => {
    return [...filtered].sort((a, b) => {
      const aVal = a[sortKey] ?? 0;
      const bVal = b[sortKey] ?? 0;
      if (typeof aVal === "string" && aVal.includes("T"))
        return sortDir === "desc"
          ? new Date(bVal) - new Date(aVal)
          : new Date(aVal) - new Date(bVal);
      if (typeof aVal === "number")
        return sortDir === "desc" ? bVal - aVal : aVal - bVal;
      return 0;
    });
  }, [filtered, sortKey, sortDir]);

  // Filtered stats
  //old one
  // const filteredStats = useMemo(() => {
  //   const total = filtered.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
  //   const avg = filtered.length ? total / filtered.length : 0;
  //   return {
  //     count: filtered.length,
  //     total: Number(total.toFixed(2)),
  //     avg: Number(avg.toFixed(2)),
  //   };
  // }, [filtered]);

  // const filteredStats = useMemo(() => {
  //   const wins = filtered.filter((t) => Number(t.pnl_amount) > 0);
  //   const losses = filtered.filter((t) => Number(t.pnl_amount) <= 0);
  //   const grossGain = wins.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
  //   const grossLoss = losses.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
  //   const net = grossGain + grossLoss;
  //   const avg = filtered.length ? net / filtered.length : 0;
  //   return {
  //     count: filtered.length,
  //     wins: wins.length,
  //     losses: losses.length,
  //     grossGain: Number(grossGain.toFixed(2)),
  //     grossLoss: Number(grossLoss.toFixed(2)),
  //     total: Number(net.toFixed(2)), // now NET, not profit-only
  //     avg: Number(avg.toFixed(2)),
  //   };
  // }, [filtered]);

  //commented on 9th sept
  // const filteredStats = useMemo(() => {
  //   const pnl = (t) =>
  //     (Number(t.exit_price) - Number(t.entry_price)) * Number(t.quantity);

  //   const wins = filtered.filter((t) => pnl(t) > 0);
  //   const losses = filtered.filter((t) => pnl(t) <= 0);
  //   const grossGain = wins.reduce((s, t) => s + pnl(t), 0);
  //   const grossLoss = losses.reduce((s, t) => s + pnl(t), 0);
  //   const net = grossGain + grossLoss;
  //   const avg = filtered.length ? net / filtered.length : 0;

  //   return {
  //     count: filtered.length,
  //     wins: wins.length,
  //     losses: losses.length,
  //     grossGain: Number(grossGain.toFixed(2)),
  //     grossLoss: Number(grossLoss.toFixed(2)),
  //     total: Number(net.toFixed(2)),
  //     avg: Number(avg.toFixed(2)),
  //   };
  // }, [filtered]);
  const filteredStats = useMemo(() => {
    // ✅ USE DB pnl_amount — it already sums partials + final leg
    const pnl = (t) => Number(t.pnl_amount || 0);

    const wins = filtered.filter((t) => pnl(t) > 0);
    const losses = filtered.filter((t) => pnl(t) <= 0);
    const grossGain = wins.reduce((s, t) => s + pnl(t), 0);
    const grossLoss = losses.reduce((s, t) => s + pnl(t), 0);
    const net = grossGain + grossLoss;
    const avg = filtered.length ? net / filtered.length : 0;

    return {
      count: filtered.length,
      wins: wins.length,
      losses: losses.length,
      grossGain: Number(grossGain.toFixed(2)),
      grossLoss: Number(grossLoss.toFixed(2)),
      total: Number(net.toFixed(2)),
      avg: Number(avg.toFixed(2)),
    };
  }, [filtered]);

  const typeLabel = (t) =>
    t === "MOMENTUM"
      ? "⚡ Momentum"
      : t === "PHROMOMENTUM"
        ? "🚀 PhroMomentum"
        : t === "PHROMOMENTUM+" // ← ADD
          ? "🚀 PhroMomentum+"
          : t === "REGMOM"
            ? "🕯️ RegMom"
            : t === "REGMOM_V2" // NEW
              ? "🚀 RegMom V2"
              : t === "PHROSTRAT"
                ? "🎯 PhroStrat"
                : t === "PHROSTRAT+"
                  ? "🎯 PhroStrat+"
                  : t === "MACDXOVER"
                    ? "📈 Crossover+"
                    : t === "CROSSOVER"
                      ? "📊 Crossover"
                      : t === "EMA_CHANNEL_PULLBACK" // ← ADD
                        ? "🎢 EMA Channel"
                        : t === "GANN_SQ9" // ← GANN
                          ? "📐 Gann Sq9"
                          : t;
  const typeBadgeCls = (t) =>
    t === "MOMENTUM"
      ? "target"
      : t === "PHROMOMENTUM"
        ? "target"
        : t === "PHROMOMENTUM+"
          ? "target"
          : t === "REGMOM"
            ? "signal"
            : t === "REGMOM_V2" // NEW
              ? "target"
              : t === "PHROSTRAT"
                ? "buy"
                : t === "PHROSTRAT+"
                  ? "buy"
                  : t === "MACDXOVER"
                    ? "target"
                    : t === "CROSSOVER"
                      ? "trail"
                      : t === "EMA_CHANNEL_PULLBACK" // ← ADD
                        ? "🎢 EMA Channel"
                        : t === "GANN_SQ9" // ← GANN
                          ? "signal"
                          : "time";

  // Group by date
  const groupedByDate = useMemo(() => {
    const groups = {};
    sorted.forEach((t) => {
      const date = new Date(t.entry_time).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      if (!groups[date]) groups[date] = { trades: [], dayPnl: 0 };
      groups[date].trades.push(t);
      groups[date].dayPnl += Number(t.pnl_amount);
    });
    return groups;
  }, [sorted]);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
    else {
      setSortKey(key);
      setSortDir("desc");
    }
  };

  const SortTh = ({ label, field, align }) => (
    <th
      onClick={() => handleSort(field)}
      className={align === "left" ? "pt__th-left" : ""}
    >
      {label}
      {sortKey === field && (
        <span className="pt__sort">{sortDir === "asc" ? " ↑" : " ↓"}</span>
      )}
    </th>
  );

  const formatTime = (ts) => {
    if (!ts) return "—";
    return new Date(ts).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getDuration = (entry, exit) => {
    if (!entry || !exit) return "—";
    const mins = Math.round((new Date(exit) - new Date(entry)) / 60000);
    if (mins < 60) return `${mins}m`;
    return `${Math.floor(mins / 60)}h ${mins % 60}m`;
  };

  const getRunningDuration = (entry) => {
    if (!entry) return "—";
    const mins = Math.round((Date.now() - new Date(entry)) / 60000);
    if (mins < 60) return `${mins}m`;
    return `${Math.floor(mins / 60)}h ${mins % 60}m`;
  };

  // Exit reason display
  const getExitBadge = (reason) => {
    const map = {
      TARGET_HIT: { icon: "🎯", label: "Target", cls: "target" },
      TRAIL_STOP: { icon: "🔒", label: "Trail", cls: "trail" },
      STOP_LOSS: { icon: "⚠️", label: "Stop loss", cls: "stoploss" },
      MARKET_CLOSE: { icon: "⏰", label: "Market close", cls: "time" },
      TIME_EXIT: { icon: "⏰", label: "Time", cls: "time" },
      SIGNALS_BEARISH: { icon: "🔄", label: "Signals", cls: "signal" },
      KEY_SIGNALS_BEARISH: { icon: "🔄", label: "Signals", cls: "signal" },
      GANN_TRAIL_STOP: { icon: "🔒", label: "Gann trail", cls: "trail" },
      MANUAL_RESET: { icon: "🔧", label: "Reset", cls: "time" },
    };
    const info = map[reason] || { icon: "❓", label: reason, cls: "time" };
    return (
      <span className={`pt__badge pt__badge--${info.cls}`}>
        {info.icon} {info.label}
      </span>
    );
  };

  const todayByType = useMemo(() => {
    const now = new Date();
    const ist = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);
    const todayStr = ist.toISOString().slice(0, 10);

    const todayTrades = (allClosedTrades || []).filter(
      (t) =>
        new Date(t.entry_time).toLocaleDateString("en-CA", {
          timeZone: "Asia/Kolkata",
        }) === todayStr,
    );

    // const buildRow = (label, trades) => {
    //   const pnl = (t) => Number(t.pnl_amount || 0);
    //   const wins = trades.filter((t) => Number(t.pnl_amount) > 0);
    //   const losses = trades.filter((t) => Number(t.pnl_amount) <= 0);
    //   const winPnl = wins.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
    //   const lossPnl = losses.reduce((s, t) => s + Number(t.pnl_amount || 0), 0);
    //   const net = winPnl + lossPnl;
    //   return {
    //     label,
    //     total: trades.length,
    //     wins: wins.length,
    //     losses: losses.length,
    //     winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
    //     winPnl,
    //     lossPnl,
    //     net,
    //   };
    // };
    const buildRow = (label, trades) => {
      const pnl = (t) => Number(t.pnl_amount || 0); // ✅ was (exit-entry)*qty

      const wins = trades.filter((t) => pnl(t) > 0);
      const losses = trades.filter((t) => pnl(t) <= 0);
      const winPnl = wins.reduce((s, t) => s + pnl(t), 0);
      const lossPnl = losses.reduce((s, t) => s + pnl(t), 0);
      const net = winPnl + lossPnl;
      return {
        label,
        total: trades.length,
        wins: wins.length,
        losses: losses.length,
        winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
        winPnl,
        lossPnl,
        net,
      };
    };

    const types = [
      //   "MOMENTUM",
      "PHROMOMENTUM",
      "PHROMOMENTUM+",

      //   "PHROSTRAT",
      //   "PHROSTRAT+",
      "REGMOM",
      "REGMOM_V2", // NEW
      "EMA_CHANNEL_PULLBACK",
      "GANN_SQ9",

      "CROSSOVER",
      //   "MACDXOVER",
    ];

    const rows = types
      .map((type) => ({
        key: type,
        ...buildRow(
          type,
          todayTrades.filter((t) => getTradeType(t) === type),
        ),
      }))
      .filter((r) => r.total > 0);

    const overall = { key: "ALL", ...buildRow("Overall", todayTrades) };
    return { rows, overall, hasData: todayTrades.length > 0 };
  }, [allClosedTrades]);

  // ─────────────────────────────────────────────────────────────
  // Reusable table renderer for closed trades (used at TOP)
  // ─────────────────────────────────────────────────────────────
  const renderClosedTradesTable = () => {
    if (loading) return <div className="pt__loading">Loading trades...</div>;
    // if (sorted.length === 0) {
    //   return (
    //     <div className="pt__empty">
    //       <div className="pt__empty-icon">📈</div>
    //       <div className="pt__empty-title">No profitable trades yet</div>
    //       <div className="pt__empty-sub">
    //         Trades appear here when target or trailing stop is hit
    //       </div>
    //     </div>
    //   );
    // }
    if (sorted.length === 0) {
      return (
        <div className="pt__empty">
          <div className="pt__empty-icon">📈</div>
          <div className="pt__empty-title">No closed trades yet</div>
          <div className="pt__empty-sub">
            Wins and losses will both appear here once trades close
          </div>
        </div>
      );
    }
    return (
      <div className="pt__table-wrap">
        <table className="pt__table stock-table">
          <thead>
            <tr>
              <SortTh label="Symbol" field="symbol" align="left" />
              <SortTh label="Entry" field="entry_price" />
              <SortTh label="Exit" field="exit_price" />
              <th>LTP</th>
              <th>Stop loss</th>
              <th>Target</th>
              <SortTh label="Qty" field="quantity" />
              <SortTh label="P&L pts" field="pnl_points" />
              <SortTh label="P&L amount" field="pnl_amount" />
              <SortTh label="Exit reason" field="exit_reason" />
              <SortTh label="Score" field="confluence_score" />
              <th>Type</th>
              <SortTh label="Entry time" field="entry_time" />
              <SortTh label="Exit time" field="exit_time" />
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {/* old code */}
            {/* {sorted.map((t) => {
              const entryPrice = Number(t.entry_price);
              const exitPrice = Number(t.exit_price);
              const quantity = Number(t.quantity);

              // BUY-only strategy
              const calculatedPnlPoints = exitPrice - entryPrice;
              const calculatedPnlAmount = calculatedPnlPoints * quantity;

              const pnlPositive = calculatedPnlAmount >= 0;

              const rawLtp =
                livePrices[t.symbol]?.ltp ?? t.snapshot_ltp ?? null;

              const ltp = rawLtp !== null ? Number(rawLtp) : null;
              const hasLtp = Number.isFinite(ltp);

              return (
                <tr
                  key={t.id}
                  className="pt__row"
                  onClick={() =>
                    navigate(`/signals/${t.symbol}/${t.security_id || ""}`)
                  }
                >
                  <td className="pt__td-name">
                    <span className="pt__symbol-name">{t.symbol}</span>
                  </td>
                  <td className="pt__num">
                    ₹
                    {Number(t.entry_price).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>
                  <td className="pt__num">
                    ₹
                    {Number(t.exit_price).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>
                  <td className="pt__num">
                    {hasLtp ? (
                      <span>
                        ₹
                        {ltp.toLocaleString("en-IN", {
                          minimumFractionDigits: 1,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    ) : (
                      <span className="pt__muted">—</span>
                    )}
                  </td>
                  <td className="pt__num pt__red">
                    ₹
                    {Number(t.stop_loss).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>
                  <td className="pt__num pt__green">
                    ₹
                    {Number(t.target).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>
                  <td className="pt__num">{t.quantity}</td>
                  <td
                    className={`pt__num ${
                      pnlPositive ? "pt__green" : "pt__red"
                    }`}
                  >
                    {calculatedPnlPoints >= 0 ? "+" : ""}
                    {calculatedPnlPoints.toFixed(1)} pts
                  </td>
                  <td
                    className={`pt__num pt__pnl-highlight ${pnlPositive ? "pt__green" : "pt__red"}`}
                  >
                    {pnlPositive ? "+" : ""}₹
                    {Math.abs(Number(t.pnl_amount)).toLocaleString("en-IN")}
                  </td>
                  <td>{getExitBadge(t.exit_reason)}</td>
                  <td className="pt__num">{t.confluence_score || "—"}/5</td>
                  <td>
                    <span
                      className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
                    >
                      {typeLabel(getTradeType(t))}
                    </span>
                  </td>
                  <td className="pt__num">{formatTime(t.entry_time)}</td>
                  <td className="pt__num">{formatTime(t.exit_time)}</td>
                  <td className="pt__num">
                    {getDuration(t.entry_time, t.exit_time)}
                  </td>
                </tr>
              );
            })} */}
            {/* new code */}
            {sorted.map((t) => {
              const quantity = Number(t.quantity);
              const totalPnlAmount = Number(t.pnl_amount || 0);

              // ✅ Effective per-share pts = amount ÷ qty
              // This is the ONLY pts value where pts × qty === amount, always.
              const effectivePnlPoints =
                quantity > 0 ? totalPnlAmount / quantity : 0;
              const pnlPositive = totalPnlAmount >= 0;

              const hadPartials =
                t.t1_hit === true ||
                t.t2_hit === true ||
                (Array.isArray(t.partial_exits) && t.partial_exits.length > 0);

              const rawLtp =
                livePrices[t.symbol]?.ltp ?? t.snapshot_ltp ?? null;
              const ltp = rawLtp !== null ? Number(rawLtp) : null;
              const hasLtp = Number.isFinite(ltp);

              return (
                <tr
                  key={t.id}
                  className="pt__row"
                  onClick={() =>
                    navigate(`/signals/${t.symbol}/${t.security_id || ""}`)
                  }
                >
                  {/* SYMBOL + partial badge */}
                  <td className="pt__td-name">
                    <span className="pt__symbol-name">{t.symbol}</span>
                    {hadPartials && (
                      <small
                        style={{
                          display: "block",
                          color: "#10b981",
                          fontSize: 10,
                          fontWeight: 600,
                          marginTop: 2,
                        }}
                      >
                        {t.t2_hit ? "T1+T2 ✓" : "T1 ✓"}
                      </small>
                    )}
                  </td>

                  {/* ENTRY */}
                  <td className="pt__num">
                    ₹
                    {Number(t.entry_price).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>

                  {/* EXIT (final leg exit price) */}
                  <td className="pt__num">
                    ₹
                    {Number(t.exit_price).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                    {hadPartials && (
                      <small
                        style={{
                          display: "block",
                          color: "#9ca3af",
                          fontSize: 9,
                          fontStyle: "italic",
                        }}
                      >
                        final leg
                      </small>
                    )}
                  </td>

                  {/* LTP */}
                  <td className="pt__num">
                    {hasLtp ? (
                      <span>
                        ₹
                        {ltp.toLocaleString("en-IN", {
                          minimumFractionDigits: 1,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    ) : (
                      <span className="pt__muted">—</span>
                    )}
                  </td>

                  {/* STOP LOSS */}
                  <td className="pt__num pt__red">
                    ₹
                    {Number(t.stop_loss).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>

                  {/* TARGET */}
                  <td className="pt__num pt__green">
                    ₹
                    {Number(t.target).toLocaleString("en-IN", {
                      minimumFractionDigits: 1,
                    })}
                  </td>

                  {/* QTY */}
                  <td className="pt__num">{quantity}</td>

                  {/* ✅ P&L PTS — always reconciled: pts × qty === amount */}
                  <td
                    className={`pt__num ${pnlPositive ? "pt__green" : "pt__red"}`}
                  >
                    {effectivePnlPoints >= 0 ? "+" : ""}
                    {effectivePnlPoints.toFixed(2)} pts
                    {hadPartials && (
                      <small
                        style={{
                          display: "block",
                          color: "#9ca3af",
                          fontSize: 9,
                          fontStyle: "italic",
                        }}
                      >
                        avg
                      </small>
                    )}
                  </td>

                  {/* P&L AMOUNT */}
                  <td
                    className={`pt__num pt__pnl-highlight ${pnlPositive ? "pt__green" : "pt__red"}`}
                  >
                    {pnlPositive ? "+" : "-"}₹
                    {Math.abs(totalPnlAmount).toLocaleString("en-IN")}
                  </td>

                  <td>{getExitBadge(t.exit_reason)}</td>
                  <td className="pt__num">{t.confluence_score || "—"}/5</td>
                  <td>
                    <span
                      className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
                    >
                      {typeLabel(getTradeType(t))}
                    </span>
                  </td>
                  <td className="pt__num">{formatTime(t.entry_time)}</td>
                  <td className="pt__num">{formatTime(t.exit_time)}</td>
                  <td className="pt__num">
                    {getDuration(t.entry_time, t.exit_time)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="pt">
      {/* Header */}
      <div className="pt__header">
        <div className="pt__header-left">
          <button className="pt__back" onClick={() => navigate(-1)}>
            <FiArrowLeft size={14} />
          </button>
          <div>
            <h1 className="pt__title">Trade Dashboard</h1>
            <p className="pt__sub">
              Live positions and trade history — BUY only strategy
            </p>
          </div>
        </div>
        <button
          className="pt__refresh"
          onClick={() => {
            navigate("/logs");
          }}
        >
          Logs
        </button>

        <button
          className="pt__refresh"
          onClick={() => {
            fetchProfitableTrades();
            fetchAllClosedTrades();
            fetchOpenTrades().then((trades) => {
              if (trades?.length) {
                connectLivePrices(trades.map((t) => t.symbol));
              }
            });
          }}
        >
          <FiRefreshCw size={14} /> Refresh
        </button>
      </div>

      {error && <div className="pt__error">{error}</div>}

      {/* ━━━ TABS ━━━ */}
      <div className="pt__tabs">
        <button
          className={`pt__tab ${activeTab === "open" ? "pt__tab--active" : ""}`}
          onClick={() => setActiveTab("open")}
        >
          <span className="pt__live-dot" />
          Open Trades
          {openTrades.length > 0 && (
            <span className="pt__tab-badge">{openTrades.length}</span>
          )}
        </button>

        <button
          className={`pt__tab ${activeTab === "history" ? "pt__tab--active" : ""}`}
          onClick={() => setActiveTab("history")}
        >
          Trade History (Close Trades)
          {filteredStats.count > 0 && (
            <span className="pt__tab-badge">{filteredStats.count}</span>
          )}
        </button>

        <button
          className={`pt__tab ${activeTab === "losses" ? "pt__tab--active" : ""}`}
          onClick={() => setActiveTab("losses")}
        >
          Losing Trades
          {filteredLossStats.count > 0 && (
            <span className="pt__tab-badge pt__tab-badge--red">
              {filteredLossStats.count}
            </span>
          )}
        </button>
      </div>

      {/* ━━━ TAB: TRADE HISTORY ━━━ */}
      {activeTab === "history" && (
        <>
          {/* ═══════════════════════════════════════════════════ */}
          {/* TOP: Type filter tabs + Main trades table          */}
          {/* ═══════════════════════════════════════════════════ */}
          <div className="pt__filters pt__filters--type">
            {[
              { id: "all", label: "All types" },
              // { id: "MOMENTUM", label: "⚡ Momentum" },
              // { id: "PHROSTRAT", label: "🎯 PhroStrat" },
              // { id: "PHROSTRAT+", label: "🎯 PhroStrat+" },
              { id: "PHROMOMENTUM", label: "🚀 PhroMomentum" },
              { id: "PHROMOMENTUM+", label: "🚀 PhroMomentum+" },
              { id: "EMA_CHANNEL_PULLBACK", label: "🎢 EMA Channel" },
              { id: "GANN_SQ9", label: "📐 Gann Sq9" },

              { id: "REGMOM", label: "🕯️ RegMom" },
              { id: "REGMOM_V2", label: "🚀 RegMom V2" }, // NEW
              // { id: "MACDXOVER", label: "📈 Crossover+" },
              // { id: "CROSSOVER", label: "📊 Crossover" },
            ].map((f) => (
              <button
                key={f.id}
                className={`pt__filter ${typeFilter === f.id ? "pt__filter--active" : ""}`}
                onClick={() => setTypeFilter(f.id)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* ─── Today by type — ABOVE the time filter ─── */}
          {todayByType.hasData && (
            <div className="pt__summary-section">
              <div className="pt__section-title">Today by type</div>
              <div className="pt__table-wrap">
                <table className="pt__table">
                  <thead>
                    <tr>
                      <th className="pt__th-left">Type</th>
                      <th>Trades</th>
                      <th>Wins</th>
                      <th>Losses</th>
                      <th>Win rate</th>
                      <th>Gain</th>
                      <th>Loss</th>
                      <th>Net P&L</th>
                    </tr>
                  </thead>
                  <tbody>
                    {todayByType.rows.map((r) => (
                      <tr key={r.key}>
                        <td className="pt__td-name">
                          <span
                            className={`pt__badge pt__badge--${typeBadgeCls(r.key)}`}
                          >
                            {typeLabel(r.key)}
                          </span>
                        </td>
                        <td className="pt__num">{r.total}</td>
                        <td className="pt__num pt__green">{r.wins}</td>
                        <td className="pt__num pt__red">{r.losses}</td>
                        <td className="pt__num">
                          <b
                            className={
                              r.winRate >= 50 ? "pt__green" : "pt__red"
                            }
                          >
                            {r.winRate.toFixed(1)}%
                          </b>
                        </td>
                        <td className="pt__num pt__green">
                          +₹
                          {r.winPnl.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </td>
                        <td className="pt__num pt__red">
                          {r.lossPnl < 0 ? "-" : ""}₹
                          {Math.abs(r.lossPnl).toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </td>
                        <td
                          className={`pt__num pt__pnl-highlight ${r.net >= 0 ? "pt__green" : "pt__red"}`}
                        >
                          {r.net >= 0 ? "+" : "-"}₹
                          {Math.abs(r.net).toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </td>
                      </tr>
                    ))}

                    <tr className="pt__summary-total">
                      <td className="pt__td-name">
                        <b>Overall (today)</b>
                      </td>
                      <td className="pt__num">
                        <b>{todayByType.overall.total}</b>
                      </td>
                      <td className="pt__num pt__green">
                        <b>{todayByType.overall.wins}</b>
                      </td>
                      <td className="pt__num pt__red">
                        <b>{todayByType.overall.losses}</b>
                      </td>
                      <td className="pt__num">
                        <b
                          className={
                            todayByType.overall.winRate >= 50
                              ? "pt__green"
                              : "pt__red"
                          }
                        >
                          {todayByType.overall.winRate.toFixed(1)}%
                        </b>
                      </td>
                      <td className="pt__num pt__green">
                        <b>
                          +₹
                          {todayByType.overall.winPnl.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                        </b>
                      </td>
                      <td className="pt__num pt__red">
                        <b>
                          {todayByType.overall.lossPnl < 0 ? "-" : ""}₹
                          {Math.abs(todayByType.overall.lossPnl).toLocaleString(
                            "en-IN",
                            {
                              maximumFractionDigits: 0,
                            },
                          )}
                        </b>
                      </td>
                      <td
                        className={`pt__num pt__pnl-highlight ${todayByType.overall.net >= 0 ? "pt__green" : "pt__red"}`}
                      >
                        <b>
                          {todayByType.overall.net >= 0 ? "+" : "-"}₹
                          {Math.abs(todayByType.overall.net).toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 },
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ─── Time Filter (All time / Today / This week) ─── */}
          <div className="pt__filters">
            {[
              // { id: "all", label: "All time" },
              { id: "today", label: "Today" },
              { id: "week", label: "This week" },
            ].map((f) => (
              <button
                key={f.id}
                className={`pt__filter ${view === f.id ? "pt__filter--active" : ""}`}
                onClick={() => setView(f.id)}
              >
                {f.label}
              </button>
            ))}
            {/* Earlier */}
            {/* <span className="pt__filter-summary">
              {filteredStats.count} trades · +₹
              {filteredStats.total.toLocaleString("en-IN")}
            </span> */}
            <span className="pt__filter-summary">
              {filteredStats.count} trades ·{" "}
              <span
                className={filteredStats.total >= 0 ? "pt__green" : "pt__red"}
              >
                {filteredStats.total >= 0 ? "+" : "-"}₹
                {Math.abs(filteredStats.total).toLocaleString("en-IN")}
              </span>
              <small style={{ marginLeft: 8, color: "#9ca3af" }}>
                ({filteredStats.wins}W / {filteredStats.losses}L)
              </small>
            </span>
          </div>

          {/* MAIN TABLE — moved to TOP */}
          {renderClosedTradesTable()}

          {/* ═══════════════════════════════════════════════════ */}
          {/* BOTTOM: Everything else                            */}
          {/* ═══════════════════════════════════════════════════ */}

          {/* Stats */}
          {stats && (
            <>
              {/* {typeSummary.rows.length > 0 && (
                <div className="pt__summary-section">
                  <div className="pt__section-title">
                    Strategy comparison ({view})
                  </div>
                  <div className="pt__table-wrap">
                    <table className="pt__table">
                      <thead>
                        <tr>
                          <th className="pt__th-left">Type</th>
                          <th>Trades</th>
                          <th>Wins</th>
                          <th>Losses</th>
                          <th>Win rate</th>
                          <th>Total P&L</th>
                          <th>Avg P&L</th>
                          <th>Avg pts</th>
                          <th>Best trade</th>
                        </tr>
                      </thead>
                      <tbody>
                        {typeSummary.rows.map((r) => (
                          <tr key={r.key}>
                            <td className="pt__td-name">
                              <span
                                className={`pt__badge pt__badge--${typeBadgeCls(r.key)}`}
                              >
                                {typeLabel(r.key)}
                              </span>
                            </td>
                            <td className="pt__num">{r.total}</td>
                            <td className="pt__num pt__green">{r.wins}</td>
                            <td className="pt__num pt__red">{r.losses}</td>
                            <td className="pt__num">
                              <b
                                className={
                                  r.winRate >= 50 ? "pt__green" : "pt__red"
                                }
                              >
                                {r.winRate.toFixed(1)}%
                              </b>
                            </td>
                            <td
                              className={`pt__num ${r.totalPnl >= 0 ? "pt__green" : "pt__red"}`}
                            >
                              {r.totalPnl >= 0 ? "+" : "-"}₹
                              {Math.abs(r.totalPnl).toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td
                              className={`pt__num ${r.avgPnl >= 0 ? "pt__green" : "pt__red"}`}
                            >
                              {r.avgPnl >= 0 ? "+" : "-"}₹
                              {Math.abs(r.avgPnl).toFixed(0)}
                            </td>
                            <td
                              className={`pt__num ${r.avgPts >= 0 ? "pt__green" : "pt__red"}`}
                            >
                              {r.avgPts >= 0 ? "+" : ""}
                              {r.avgPts.toFixed(1)}
                            </td>
                            <td className="pt__num">
                              {r.best
                                ? `${r.best.symbol} +₹${Number(r.best.pnl_amount).toFixed(0)}`
                                : "—"}
                            </td>
                          </tr>
                        ))}

                     
                        <tr className="pt__summary-total">
                          <td className="pt__td-name">
                            <b>Overall</b>
                          </td>
                          <td className="pt__num">
                            <b>{typeSummary.overall.total}</b>
                          </td>
                          <td className="pt__num pt__green">
                            <b>{typeSummary.overall.wins}</b>
                          </td>
                          <td className="pt__num pt__red">
                            <b>{typeSummary.overall.losses}</b>
                          </td>
                          <td className="pt__num">
                            <b
                              className={
                                typeSummary.overall.winRate >= 50
                                  ? "pt__green"
                                  : "pt__red"
                              }
                            >
                              {typeSummary.overall.winRate.toFixed(1)}%
                            </b>
                          </td>
                          <td
                            className={`pt__num ${typeSummary.overall.totalPnl >= 0 ? "pt__green" : "pt__red"}`}
                          >
                            <b>
                              {typeSummary.overall.totalPnl >= 0 ? "+" : "-"}₹
                              {Math.abs(
                                typeSummary.overall.totalPnl,
                              ).toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })}
                            </b>
                          </td>
                          <td
                            className={`pt__num ${typeSummary.overall.avgPnl >= 0 ? "pt__green" : "pt__red"}`}
                          >
                            <b>
                              {typeSummary.overall.avgPnl >= 0 ? "+" : "-"}₹
                              {Math.abs(typeSummary.overall.avgPnl).toFixed(0)}
                            </b>
                          </td>
                          <td
                            className={`pt__num ${typeSummary.overall.avgPts >= 0 ? "pt__green" : "pt__red"}`}
                          >
                            <b>
                              {typeSummary.overall.avgPts >= 0 ? "+" : ""}
                              {typeSummary.overall.avgPts.toFixed(1)}
                            </b>
                          </td>
                          <td className="pt__num">—</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )} */}

              {/* previous code */}
              {/* <div className="pt__stats">
                <div className="pt__stat pt__stat--highlight">
                  <span>Total profit</span>
                  <b>+₹{filteredStats.total.toLocaleString("en-IN")}</b>
                </div>
                <div className="pt__stat">
                  <span>Winning trades</span>
                  <b>{filteredStats.count}</b>
                </div>
                <div className="pt__stat">
                  <span>Avg profit / trade</span>
                  <b>+₹{filteredStats.avg.toLocaleString("en-IN")}</b>
                </div>
                <div className="pt__stat">
                  <span>Avg points / trade</span>
                  <b>+{stats.avgPoints} pts</b>
                </div>
                {stats.bestTrade && (
                  <div className="pt__stat">
                    <span>Best trade</span>
                    <b>
                      {stats.bestTrade.symbol} +₹
                      {Number(stats.bestTrade.pnl_amount).toLocaleString(
                        "en-IN",
                      )}
                    </b>
                  </div>
                )}
              </div> */}
              <div className="pt__stats">
                <div className={`pt__stat pt__stat--highlight`}>
                  <span>Net P&L</span>
                  <b
                    className={
                      filteredStats.total >= 0 ? "pt__green" : "pt__red"
                    }
                  >
                    {filteredStats.total >= 0 ? "+" : "-"}₹
                    {Math.abs(filteredStats.total).toLocaleString("en-IN")}
                  </b>
                </div>
                <div className="pt__stat">
                  <span>Gross gain</span>
                  <b className="pt__green">
                    +₹{filteredStats.grossGain.toLocaleString("en-IN")}
                  </b>
                </div>
                <div className="pt__stat">
                  <span>Gross loss</span>
                  <b className="pt__red">
                    -₹
                    {Math.abs(filteredStats.grossLoss).toLocaleString("en-IN")}
                  </b>
                </div>
                <div className="pt__stat">
                  <span>Total trades</span>
                  <b>
                    {filteredStats.count}{" "}
                    <small style={{ color: "#9ca3af" }}>
                      ({filteredStats.wins}W / {filteredStats.losses}L)
                    </small>
                  </b>
                </div>
                <div className="pt__stat">
                  <span>Win rate</span>
                  <b
                    className={
                      filteredStats.count &&
                      filteredStats.wins / filteredStats.count >= 0.5
                        ? "pt__green"
                        : "pt__red"
                    }
                  >
                    {filteredStats.count
                      ? (
                          (filteredStats.wins / filteredStats.count) *
                          100
                        ).toFixed(1)
                      : "0.0"}
                    %
                  </b>
                </div>
                <div className="pt__stat">
                  <span>Avg P&L / trade</span>
                  <b
                    className={filteredStats.avg >= 0 ? "pt__green" : "pt__red"}
                  >
                    {filteredStats.avg >= 0 ? "+" : "-"}₹
                    {Math.abs(filteredStats.avg).toLocaleString("en-IN")}
                  </b>
                </div>
              </div>

              {allStats && (
                <div className="pt__stat">
                  <span>Overall win rate</span>
                  <b>
                    {allStats.winRate}% ({allStats.winners}W / {allStats.losers}
                    L)
                  </b>
                </div>
              )}
            </>
          )}

          {/* How profits were made */}
          {stats?.byReason && Object.keys(stats.byReason).length > 0 && (
            <div className="pt__reason-section">
              <div className="pt__section-title">
                How trades generate profit
              </div>
              <div className="pt__reason-row">
                {Object.entries(stats.byReason).map(([reason, data]) => (
                  <div key={reason} className="pt__reason-card">
                    <span
                      className={`pt__reason-badge pt__reason-badge--${reason.toLowerCase()}`}
                    >
                      {/* {reason === "TARGET_HIT"
                        ? "🎯"
                        : reason === "TRAIL_STOP"
                          ? "🔒"
                          : "⏰"}{" "} */}
                      {reason === "TARGET_HIT"
                        ? "🎯"
                        : reason === "TRAIL_STOP" ||
                            reason === "GANN_TRAIL_STOP" // ← GANN
                          ? "🔒"
                          : reason === "BE_STOP" // ← GANN
                            ? "🛡️"
                            : "⏰"}{" "}
                      {reason.replace(/_/g, " ")}
                    </span>
                    <b>{data.count} trades</b>
                    <small>+₹{data.total.toFixed(0)}</small>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Top Symbols */}
          {stats?.topSymbols?.length > 0 && (
            <div className="pt__top-section">
              <div className="pt__section-title">Top profitable stocks</div>
              <div className="pt__symbol-chips">
                {stats.topSymbols.map((s) => (
                  <div
                    key={s.symbol}
                    className="pt__symbol-chip"
                    onClick={() => navigate(`/stockdetail/${s.symbol}`)}
                  >
                    <span className="pt__chip-name">{s.symbol}</span>
                    <span className="pt__chip-pnl">+₹{s.total.toFixed(0)}</span>
                    <small>{s.count} trades</small>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Day-wise summary */}
          {Object.keys(groupedByDate).length > 0 && (
            <div className="pt__day-section">
              <div className="pt__section-title">Day-wise profit</div>
              <div className="pt__day-grid">
                {Object.entries(groupedByDate).map(([date, data]) => (
                  <div key={date} className="pt__day-card">
                    <span className="pt__day-date">{date}</span>
                    <b className="pt__green">+₹{data.dayPnl.toFixed(0)}</b>
                    <small>{data.trades.length} winning trades</small>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Explainer */}
          <div className="pt__explainer">
            <div className="pt__section-title">How trades generate profit</div>
            <div className="pt__explain-grid">
              <div className="pt__explain-card">
                <h5>🎯 Target hit</h5>
                <p>
                  Price moved up and reached the target price (entry + 50 pts).
                  Full planned profit captured.
                </p>
              </div>
              <div className="pt__explain-card">
                <h5>🔒 Trailing stop</h5>
                <p>
                  Price moved past the target. Trailing stop locked profits by
                  following the price 15 pts behind. Captured more than the
                  planned target.
                </p>
              </div>
              <div className="pt__explain-card">
                <h5>⏰ Market close</h5>
                <p>
                  Trade was still profitable at 3:15 PM. Auto-sold before market
                  close to avoid overnight risk.
                </p>
              </div>
              <div className="pt__explain-card">
                <h5>⚠️ Stop loss</h5>
                <p>
                  Price dropped below the stop loss (entry - 25 pts). Auto-sold
                  to limit the damage. Max loss is always capped.
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ━━━ TAB: LOSING TRADES ━━━ */}
      {activeTab === "losses" && (
        <>
          {/* Type filter (reuse existing typeFilter state) */}
          <div className="pt__filters pt__filters--type">
            {[
              { id: "all", label: "All types" },
              // { id: "MOMENTUM", label: "⚡ Momentum" },
              { id: "PHROMOMENTUM", label: "🚀 PhroMomentum" },
              { id: "PHROMOMENTUM+", label: "🚀 PhroMomentum+" }, // ← AD
              // { id: "PHROSTRAT", label: "🎯 PhroStrat" },
              // { id: "PHROSTRAT+", label: "🎯 PhroStrat+" },

              { id: "REGMOM", label: "🕯️ RegMom" },
              { id: "REGMOM_V2", label: "🚀 RegMom V2" },
              // { id: "MACDXOVER", label: "📈 Crossover+" },
              // { id: "CROSSOVER", label: "📊 Crossover" },
            ].map((f) => (
              <button
                key={f.id}
                className={`pt__filter ${typeFilter === f.id ? "pt__filter--active" : ""}`}
                onClick={() => setTypeFilter(f.id)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Time filter */}
          <div className="pt__filters">
            {[
              // { id: "all", label: "All time" },
              { id: "today", label: "Today" },
              { id: "week", label: "This week" },
            ].map((f) => (
              <button
                key={f.id}
                className={`pt__filter ${view === f.id ? "pt__filter--active" : ""}`}
                onClick={() => setView(f.id)}
              >
                {f.label}
              </button>
            ))}
            <span className="pt__filter-summary">
              {filteredLossStats.count} trades · -₹
              {Math.abs(filteredLossStats.total).toLocaleString("en-IN")}
            </span>
          </div>

          {/* Losses table */}
          {loading ? (
            <div className="pt__loading">Loading losing trades...</div>
          ) : sortedLosses.length === 0 ? (
            <div className="pt__empty">
              <div className="pt__empty-icon">🎉</div>
              <div className="pt__empty-title">No losing trades</div>
              <div className="pt__empty-sub">
                All trades in this window were profitable
              </div>
            </div>
          ) : (
            <div className="pt__table-wrap">
              <table className="pt__table stock-table">
                <thead>
                  <tr>
                    <SortTh label="Symbol" field="symbol" align="left" />
                    <SortTh label="Entry" field="entry_price" />
                    <SortTh label="Exit" field="exit_price" />
                    <th>LTP</th>
                    <th>Stop loss</th>
                    <th>Target</th>
                    <SortTh label="Qty" field="quantity" />
                    <SortTh label="P&L pts" field="pnl_points" />
                    <SortTh label="P&L amount" field="pnl_amount" />
                    <SortTh label="Exit reason" field="exit_reason" />
                    <SortTh label="Score" field="confluence_score" />
                    <th>Type</th>
                    <SortTh label="Entry time" field="entry_time" />
                    <SortTh label="Exit time" field="exit_time" />
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedLosses.map((t) => {
                    const entryPrice = Number(t.entry_price);
                    const exitPrice = Number(t.exit_price);
                    const calculatedPnlPoints = exitPrice - entryPrice;
                    const rawLtp =
                      livePrices[t.symbol]?.ltp ?? t.snapshot_ltp ?? null;
                    const ltp = rawLtp !== null ? Number(rawLtp) : null;
                    const hasLtp = Number.isFinite(ltp);

                    return (
                      <tr
                        key={t.id}
                        className="pt__row"
                        onClick={() =>
                          navigate(
                            `/signals/${t.symbol}/${t.security_id || ""}`,
                          )
                        }
                      >
                        <td className="pt__td-name">
                          <span className="pt__symbol-name">{t.symbol}</span>
                        </td>
                        <td className="pt__num">
                          ₹
                          {Number(t.entry_price).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                          })}
                        </td>
                        <td className="pt__num">
                          ₹
                          {Number(t.exit_price).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                          })}
                        </td>
                        <td className="pt__num">
                          {hasLtp ? (
                            <span>
                              ₹
                              {ltp.toLocaleString("en-IN", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          ) : (
                            <span className="pt__muted">—</span>
                          )}
                        </td>
                        <td className="pt__num pt__red">
                          ₹
                          {Number(t.stop_loss).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                          })}
                        </td>
                        <td className="pt__num pt__green">
                          ₹
                          {Number(t.target).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                          })}
                        </td>
                        <td className="pt__num">{t.quantity}</td>
                        <td className="pt__num pt__red">
                          {calculatedPnlPoints.toFixed(1)} pts
                        </td>
                        <td className="pt__num pt__pnl-highlight pt__red">
                          -₹
                          {Math.abs(Number(t.pnl_amount)).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        <td>{getExitBadge(t.exit_reason)}</td>
                        <td className="pt__num">
                          {t.confluence_score || "—"}/5
                        </td>
                        <td>
                          <span
                            className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
                          >
                            {typeLabel(getTradeType(t))}
                          </span>
                        </td>
                        <td className="pt__num">{formatTime(t.entry_time)}</td>
                        <td className="pt__num">{formatTime(t.exit_time)}</td>
                        <td className="pt__num">
                          {getDuration(t.entry_time, t.exit_time)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Loss stats */}
          {lossStats && (
            <div className="pt__stats">
              <div
                className="pt__stat pt__stat--highlight"
                style={{ borderColor: "#ef4444" }}
              >
                <span>Total loss</span>
                <b className="pt__red">
                  -₹{Math.abs(filteredLossStats.total).toLocaleString("en-IN")}
                </b>
              </div>
              <div className="pt__stat">
                <span>Losing trades</span>
                <b>{filteredLossStats.count}</b>
              </div>
              <div className="pt__stat">
                <span>Avg loss / trade</span>
                <b className="pt__red">
                  -₹{Math.abs(filteredLossStats.avg).toLocaleString("en-IN")}
                </b>
              </div>
              <div className="pt__stat">
                <span>Avg points / trade</span>
                <b className="pt__red">{lossStats.avgPoints} pts</b>
              </div>
              {lossStats.worstTrade && (
                <div className="pt__stat">
                  <span>Worst trade</span>
                  <b className="pt__red">
                    {lossStats.worstTrade.symbol} -₹
                    {Math.abs(
                      Number(lossStats.worstTrade.pnl_amount),
                    ).toLocaleString("en-IN")}
                  </b>
                </div>
              )}
            </div>
          )}

          {/* WHY trades failed */}
          {lossStats?.byReason &&
            Object.keys(lossStats.byReason).length > 0 && (
              <div className="pt__reason-section">
                <div className="pt__section-title">Why trades failed</div>
                <div className="pt__reason-row">
                  {Object.entries(lossStats.byReason)
                    .sort((a, b) => a[1].total - b[1].total)
                    .map(([reason, data]) => (
                      <div key={reason} className="pt__reason-card">
                        <span
                          className={`pt__reason-badge pt__reason-badge--${reason.toLowerCase()}`}
                        >
                          {reason === "STOP_LOSS"
                            ? "⚠️"
                            : reason === "MARKET_CLOSE"
                              ? "⏰"
                              : reason === "SIGNALS_BEARISH" ||
                                  reason === "KEY_SIGNALS_BEARISH"
                                ? "🔄"
                                : // : reason === "TIME_EXIT"
                                  //   ? "⏰"
                                  //   : "❓"}{" "}
                                  reason === "TIME_EXIT"
                                  ? "⏰"
                                  : reason === "BE_STOP" // ← GANN
                                    ? "🛡️"
                                    : reason === "GANN_TRAIL_STOP" // ← GANN
                                      ? "🔒"
                                      : "❓"}{" "}
                          {reason.replace(/_/g, " ")}
                        </span>
                        <b>{data.count} trades</b>
                        <small className="pt__red">
                          -₹{Math.abs(data.total).toFixed(0)}
                        </small>
                      </div>
                    ))}
                </div>
              </div>
            )}

          {/* Which strategies lose most */}
          {lossStats?.byType && Object.keys(lossStats.byType).length > 0 && (
            <div className="pt__reason-section">
              <div className="pt__section-title">Losses by strategy</div>
              <div className="pt__reason-row">
                {Object.entries(lossStats.byType)
                  .sort((a, b) => a[1].total - b[1].total)
                  .map(([type, data]) => (
                    <div key={type} className="pt__reason-card">
                      <span
                        className={`pt__badge pt__badge--${typeBadgeCls(type)}`}
                      >
                        {typeLabel(type)}
                      </span>
                      <b>{data.count} trades</b>
                      <small className="pt__red">
                        -₹{Math.abs(data.total).toFixed(0)}
                      </small>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {/* Worst stocks */}
          {lossStats?.worstSymbols?.length > 0 && (
            <div className="pt__top-section">
              <div className="pt__section-title">Worst performing stocks</div>
              <div className="pt__symbol-chips">
                {lossStats.worstSymbols.map((s) => (
                  <div
                    key={s.symbol}
                    className="pt__symbol-chip"
                    onClick={() => navigate(`/stockdetail/${s.symbol}`)}
                  >
                    <span className="pt__chip-name">{s.symbol}</span>
                    <span className="pt__chip-pnl pt__red">
                      -₹{Math.abs(s.total).toFixed(0)}
                    </span>
                    <small>{s.count} trades</small>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Day-wise loss summary */}
          {Object.keys(groupedLossesByDate).length > 0 && (
            <div className="pt__day-section">
              <div className="pt__section-title">Day-wise losses</div>
              <div className="pt__day-grid">
                {Object.entries(groupedLossesByDate).map(([date, data]) => (
                  <div key={date} className="pt__day-card">
                    <span className="pt__day-date">{date}</span>
                    <b className="pt__red">
                      -₹{Math.abs(data.dayPnl).toFixed(0)}
                    </b>
                    <small>{data.trades.length} losing trades</small>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      <div className="pt__tabs pt__tabs--strategy">
        {/* {["v1", "v2", "v2plus", "momentum", "macdxover", "regmom"].map((v) => { */}
        {[
          // "v1",
          // "v2plus",
          "momentum",
          // "momentum_plus",
          "regmom",
          "regmom_v2",
          "ema_channel",
          "gann",
        ].map((v) => {
          const labels = {
            // v1: "Strategy 1",
            // v2: "Strategy 2 (PhroStrat)",
            // v2plus: "Strategy 2 (PhroStrat+)",
            momentum: "Strategy 3 (Momentum)",
            momentum_plus: "Strategy 4 (Momentum+)",
            // macdxover: "Strategy 5 (Crossover+)",
            regmom: "Strategy 4 (RegMom)",
            regmom_v2: "Strategy 5 (RegMomv2)",
            ema_channel: "Strategy 6 (EMA Channel)",
            gann: "Strategy 7 (Gann Sq9)",
          };
          return (
            <button
              key={v}
              className={`pt__tab ${activeStrategy === v ? "pt__tab--active" : ""}`}
              onClick={() => setActiveStrategy(v)}
            >
              {labels[v]}
              <span className="pt__tab-badge">
                {openTrades.filter((t) => (t.strategy || "v1") === v).length}
              </span>
            </button>
          );
        })}
      </div>

      {/* ━━━ TAB: OPEN POSITIONS ━━━ */}
      {activeTab === "open" && (
        <>
          {openTrades.length > 0 ? (
            <div className="pt__open-section">
              <div className="pt__section-title">
                <span className="pt__live-dot" />
                Open positions ({openTrades.length})
              </div>
              <div className="pt__table-wrap">
                <table className="pt__table ">
                  <thead>
                    <tr>
                      <th className="pt__th-left">Symbol</th>
                      <th>Entry</th>
                      <th>LTP</th>
                      <th>Stop loss</th>
                      <th>Target</th>
                      <th>Qty</th>
                      <th>Live P&L</th>
                      <th>Score</th>
                      <th>Type</th>
                      <th>Progress</th>
                      <th>Running</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {stratOpen?.map((t) => {
                      const ltp =
                        livePrices[t.symbol]?.ltp || t.snapshot_ltp || null;
                      const pnl = ltp
                        ? (ltp - t.entry_price) * t.quantity
                        : null;
                      const pnlPts = ltp ? ltp - t.entry_price : null;
                      const isProfit = pnl !== null && pnl >= 0;

                      // Progress: how far between SL and Target
                      const totalRange = t.target - t.stop_loss;
                      const currentPos = ltp
                        ? ((ltp - t.stop_loss) / totalRange) * 100
                        : 50;
                      const clampedProgress = Math.max(
                        0,
                        Math.min(100, currentPos),
                      );

                      return (
                        <tr
                          key={t.id}
                          className="pt__row pt__row--open"
                          onClick={() =>
                            navigate(
                              `/signals/${t.symbol}/${t.security_id || ""}`,
                            )
                          }
                        >
                          <td className="pt__td-name">
                            <span className="pt__symbol-name">{t.symbol}</span>
                            <span className="pt__badge pt__badge--buy">
                              BUY
                            </span>
                          </td>
                          <td className="pt__num">
                            ₹
                            {Number(t.entry_price).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                          </td>
                          <td className="pt__num">
                            {ltp ? (
                              <span
                                className={isProfit ? "pt__green" : "pt__red"}
                              >
                                ₹
                                {ltp.toLocaleString("en-IN", {
                                  minimumFractionDigits: 1,
                                })}
                                <small className="pt__ltp-diff">
                                  {" "}
                                  ({pnlPts >= 0 ? "+" : ""}
                                  {pnlPts?.toFixed(1)})
                                </small>
                              </span>
                            ) : (
                              <span className="pt__muted">—</span>
                            )}
                          </td>
                          <td className="pt__num pt__red">
                            ₹
                            {Number(t.stop_loss).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                          </td>
                          <td className="pt__num pt__green">
                            ₹
                            {Number(t.target).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                          </td>
                          <td className="pt__num">{t.quantity}</td>
                          <td className="pt__num">
                            {pnl !== null ? (
                              <span
                                className={`pt__pnl-highlight ${isProfit ? "pt__green" : "pt__red"}`}
                              >
                                {isProfit ? "+" : ""}₹{Math.abs(pnl).toFixed(0)}
                              </span>
                            ) : (
                              "—"
                            )}
                          </td>
                          <td className="pt__num">
                            {t.confluence_score || "—"}/5
                          </td>
                          <td>
                            <span
                              className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
                            >
                              {typeLabel(getTradeType(t))}
                            </span>
                          </td>
                          <td className="pt__num" style={{ minWidth: 100 }}>
                            <div className="pt__progress-bar">
                              <div
                                className={`pt__progress-fill ${isProfit ? "pt__progress-fill--green" : "pt__progress-fill--red"}`}
                                style={{ width: `${clampedProgress}%` }}
                              />
                              <div
                                className="pt__progress-entry"
                                style={{
                                  left: `${((t.entry_price - t.stop_loss) / totalRange) * 100}%`,
                                }}
                              />
                            </div>
                            <small className="pt__progress-label">
                              {ltp && ltp >= t.entry_price
                                ? `${Math.round(((ltp - t.entry_price) / (t.target - t.entry_price)) * 100)}% to target`
                                : ltp
                                  ? `${Math.round(((t.entry_price - ltp) / (t.entry_price - t.stop_loss)) * 100)}% to SL`
                                  : "waiting..."}
                            </small>
                          </td>
                          <td className="pt__num pt__muted">
                            {getRunningDuration(t.entry_time)}
                          </td>
                        </tr>
                      );
                    })} */}
                    {stratOpen?.map((t) => {
                      const ltp =
                        livePrices[t.symbol]?.ltp || t.snapshot_ltp || null;

                      // ─── PARTIAL-EXIT AWARE P&L ───────────────────
                      const originalQty = Number(t.quantity);
                      const remainingQty = Number(
                        t.remaining_qty ?? t.quantity,
                      );
                      const realizedPnl = Number(t.realized_pnl_amount || 0);
                      const soldQty = originalQty - remainingQty;

                      const unrealizedPnl = ltp
                        ? (ltp - t.entry_price) * remainingQty
                        : null;
                      const pnl =
                        ltp !== null
                          ? realizedPnl + unrealizedPnl
                          : realizedPnl || null;
                      const pnlPts = ltp ? ltp - t.entry_price : null;
                      const isProfit = pnl !== null && pnl >= 0;

                      // ─── LIFECYCLE FLAGS ──────────────────────────
                      const t1Hit = t.t1_hit === true;
                      const t2Hit = t.t2_hit === true;
                      const slAtBE =
                        t.stop_loss != null &&
                        Number(t.stop_loss).toFixed(2) ===
                          Number(t.entry_price).toFixed(2);

                      // Progress: how far between SL and Target
                      const totalRange = t.target - t.stop_loss;
                      const currentPos = ltp
                        ? ((ltp - t.stop_loss) / totalRange) * 100
                        : 50;
                      const clampedProgress = Math.max(
                        0,
                        Math.min(100, currentPos),
                      );

                      return (
                        <tr
                          key={t.id}
                          className="pt__row pt__row--open"
                          onClick={() =>
                            navigate(
                              `/signals/${t.symbol}/${t.security_id || ""}`,
                            )
                          }
                        >
                          <td className="pt__td-name">
                            <span className="pt__symbol-name">{t.symbol}</span>
                            <span className="pt__badge pt__badge--buy">
                              BUY
                            </span>
                            {t1Hit && !t2Hit && (
                              <span
                                className="pt__badge pt__badge--target"
                                style={{ marginLeft: 4 }}
                              >
                                T1 ✓
                              </span>
                            )}
                            {t2Hit && (
                              <span
                                className="pt__badge pt__badge--target"
                                style={{ marginLeft: 4 }}
                              >
                                T2 ✓
                              </span>
                            )}
                          </td>
                          <td className="pt__num">
                            ₹
                            {Number(t.entry_price).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                          </td>
                          <td className="pt__num">
                            {ltp ? (
                              <span
                                className={isProfit ? "pt__green" : "pt__red"}
                              >
                                ₹
                                {ltp.toLocaleString("en-IN", {
                                  minimumFractionDigits: 1,
                                })}
                                <small className="pt__ltp-diff">
                                  {" "}
                                  ({pnlPts >= 0 ? "+" : ""}
                                  {pnlPts?.toFixed(1)})
                                </small>
                              </span>
                            ) : (
                              <span className="pt__muted">—</span>
                            )}
                          </td>
                          <td className="pt__num pt__red">
                            ₹
                            {Number(t.stop_loss).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                            {slAtBE && (
                              <small
                                style={{
                                  color: "#3b82f6",
                                  marginLeft: 4,
                                  fontWeight: 600,
                                }}
                              >
                                BE
                              </small>
                            )}
                            {t2Hit && (
                              <small
                                style={{
                                  color: "#10b981",
                                  marginLeft: 4,
                                  fontWeight: 600,
                                }}
                              >
                                TRAIL
                              </small>
                            )}
                          </td>
                          <td className="pt__num pt__green">
                            ₹
                            {Number(t.target).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                            })}
                            {t.t1_price && (
                              <small
                                style={{ display: "block", color: "#9ca3af" }}
                              >
                                T1: ₹{Number(t.t1_price).toFixed(1)}
                              </small>
                            )}
                          </td>
                          <td className="pt__num">
                            {remainingQty}
                            {soldQty > 0 && (
                              <small
                                style={{ display: "block", color: "#9ca3af" }}
                              >
                                of {originalQty}
                              </small>
                            )}
                          </td>
                          <td className="pt__num">
                            {pnl !== null ? (
                              <span
                                className={`pt__pnl-highlight ${isProfit ? "pt__green" : "pt__red"}`}
                              >
                                {isProfit ? "+" : "-"}₹
                                {Math.abs(pnl).toFixed(0)}
                                {realizedPnl > 0 && (
                                  <small
                                    style={{
                                      display: "block",
                                      color: "#10b981",
                                      fontWeight: 500,
                                    }}
                                  >
                                    ✓ ₹{realizedPnl.toFixed(0)} locked
                                  </small>
                                )}
                              </span>
                            ) : (
                              "—"
                            )}
                          </td>
                          <td className="pt__num">
                            {t.confluence_score || "—"}/5
                          </td>
                          <td>
                            <span
                              className={`pt__badge pt__badge--${typeBadgeCls(getTradeType(t))}`}
                            >
                              {typeLabel(getTradeType(t))}
                            </span>
                          </td>
                          <td className="pt__num" style={{ minWidth: 100 }}>
                            <div className="pt__progress-bar">
                              <div
                                className={`pt__progress-fill ${isProfit ? "pt__progress-fill--green" : "pt__progress-fill--red"}`}
                                style={{ width: `${clampedProgress}%` }}
                              />
                              <div
                                className="pt__progress-entry"
                                style={{
                                  left: `${((t.entry_price - t.stop_loss) / totalRange) * 100}%`,
                                }}
                              />
                            </div>
                            <small className="pt__progress-label">
                              {ltp && ltp >= t.entry_price
                                ? `${Math.round(((ltp - t.entry_price) / (t.target - t.entry_price)) * 100)}% to target`
                                : ltp
                                  ? `${Math.round(((t.entry_price - ltp) / (t.entry_price - t.stop_loss)) * 100)}% to SL`
                                  : "waiting..."}
                            </small>
                          </td>
                          <td className="pt__num pt__muted">
                            {getRunningDuration(t.entry_time)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="pt__empty">
              <div className="pt__empty-icon">📭</div>
              <div className="pt__empty-title">No open positions</div>
              <div className="pt__empty-sub">
                Active trades will appear here with live P&L tracking
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default TradeDealPage1;
